const unlayerTemplates = [{
    "id": 1457,
    "name": "One Last Email",
    "slug": "one-last-email",
    "rating": 4.62,
    "votes": {
        "3": 2,
        "4": 9,
        "5": 23
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/one-last-email/1658318614584.png",
    "__typename": "StockTemplate"
}, {
    "id": 1456,
    "name": "Sales Follow Up ",
    "slug": "sales-follow-up",
    "rating": null,
    "votes": {},
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sales-follow-up/1658727330990.png",
    "__typename": "StockTemplate"
}, {
    "id": 1455,
    "name": "Trigger Event",
    "slug": "trigger-event",
    "rating": 4.72,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/trigger-event/1658468982594.png",
    "__typename": "StockTemplate"
}, {
    "id": 1452,
    "name": "Sales Introduction",
    "slug": "sales-introduction",
    "rating": 4.57,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sales-introduction/1658468882917.png",
    "__typename": "StockTemplate"
}, {
    "id": 1450,
    "name": "Permission email template",
    "slug": "permission-email-template",
    "rating": 4.38,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 2,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/permission-email-template/1658468343715.png",
    "__typename": "StockTemplate"
}, {
    "id": 1449,
    "name": "Order Confirmation",
    "slug": "order-confirmation",
    "rating": 4.46,
    "votes": {
        "1": 11,
        "2": 3,
        "3": 12,
        "4": 16,
        "5": 131
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/order-confirmation/1656662613677.png",
    "__typename": "StockTemplate"
}, {
    "id": 1432,
    "name": "SPA Reservation",
    "slug": "spa-reservation",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/spa-reservation/1656654732962.png",
    "__typename": "StockTemplate"
}, {
    "id": 1427,
    "name": "Mountain Bikes Tourism Day Deal",
    "slug": "mountain-bikes-tourism-day-deal",
    "rating": 4.95,
    "votes": {
        "4": 1,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mountain-bikes-tourism-day-deal/1656577465024.png",
    "__typename": "StockTemplate"
}, {
    "id": 1425,
    "name": "Hiking Boots Discount ",
    "slug": "hiking-boots-discount",
    "rating": 3.6,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hiking-boots-discount/1656577282500.png",
    "__typename": "StockTemplate"
}, {
    "id": 1422,
    "name": "Holiday Season Real Estate Discount ",
    "slug": "holiday-season-real-estate-discount",
    "rating": 4.59,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 7,
        "5": 25
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/holiday-season-real-estate-discount/1656576983080.png",
    "__typename": "StockTemplate"
}, {
    "id": 1420,
    "name": "Save the Date Holiday Party",
    "slug": "save-the-date-holiday-party",
    "rating": 4.71,
    "votes": {
        "3": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/save-the-date-holiday-party/1656576915992.png",
    "__typename": "StockTemplate"
}, {
    "id": 1413,
    "name": "Birthday Discounts",
    "slug": "birthday-discounts",
    "rating": 4.57,
    "votes": {
        "3": 3,
        "4": 4,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/birthday-discounts/1655875909491.png",
    "__typename": "StockTemplate"
}, {
    "id": 1402,
    "name": "Father's Day Perfume Sale",
    "slug": "fathers-day-perfume-sale",
    "rating": 4.27,
    "votes": {
        "1": 5,
        "3": 1,
        "4": 5,
        "5": 26
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fathers-day-perfume-sale/1655119497045.png",
    "__typename": "StockTemplate"
}, {
    "id": 1399,
    "name": "Juneteenth Invitation ",
    "slug": "juneteenth-invitation",
    "rating": 4.42,
    "votes": {
        "1": 4,
        "2": 5,
        "3": 6,
        "4": 13,
        "5": 68
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/juneteenth-invitation/1657002419983.png",
    "__typename": "StockTemplate"
}, {
    "id": 1398,
    "name": "Juneteenth Pre School Activates ",
    "slug": "juneteenth-pre-school-activates",
    "rating": 4.27,
    "votes": {
        "1": 4,
        "2": 1,
        "3": 4,
        "4": 6,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/juneteenth-pre-school-activates/1653390690738.png",
    "__typename": "StockTemplate"
}, {
    "id": 1397,
    "name": "Juneteenth March Announcement",
    "slug": "juneteenth-march-announcement",
    "rating": 4.65,
    "votes": {
        "1": 1,
        "2": 2,
        "4": 14,
        "5": 52
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/juneteenth-march-announcement/1657002556707.png",
    "__typename": "StockTemplate"
}, {
    "id": 1390,
    "name": "Corporate Anniversary",
    "slug": "corporate-anniversary",
    "rating": 4.69,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 2,
        "4": 2,
        "5": 48
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/corporate-anniversary/1653391908271.png",
    "__typename": "StockTemplate"
}, {
    "id": 1387,
    "name": "Customer Anniversary",
    "slug": "client-anniversary",
    "rating": 4.39,
    "votes": {
        "1": 2,
        "3": 4,
        "4": 4,
        "5": 23
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/client-anniversary/1653392208818.png",
    "__typename": "StockTemplate"
}, {
    "id": 1380,
    "name": "Back in Stock Announcement ",
    "slug": "back-in-stock-announcement",
    "rating": 4.68,
    "votes": {
        "3": 5,
        "4": 8,
        "5": 44
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/back-in-stock-announcement/1653464480155.png",
    "__typename": "StockTemplate"
}, {
    "id": 1373,
    "name": "Beauty Products Back in Stock",
    "slug": "beauty-products-back-in-stock",
    "rating": 4.08,
    "votes": {
        "1": 5,
        "2": 3,
        "3": 2,
        "4": 4,
        "5": 26
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/beauty-products-back-in-stock/1653464930896.png",
    "__typename": "StockTemplate"
}, {
    "id": 1369,
    "name": "Retirement Party",
    "slug": "retirement-party",
    "rating": 4.27,
    "votes": {
        "1": 9,
        "3": 3,
        "4": 6,
        "5": 48
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/retirement-party/1651127451234.png",
    "__typename": "StockTemplate"
}, {
    "id": 1365,
    "name": "News Subscription",
    "slug": "news-subscription",
    "rating": 4.63,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 2,
        "4": 13,
        "5": 58
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/news-subscription/1651133027513.png",
    "__typename": "StockTemplate"
}, {
    "id": 1364,
    "name": "Marketing Agency Invoice",
    "slug": "marketing-agency-invoice",
    "rating": 4.59,
    "votes": {
        "1": 2,
        "3": 3,
        "4": 8,
        "5": 41
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/marketing-agency-invoice/1651127971073.png",
    "__typename": "StockTemplate"
}, {
    "id": 1362,
    "name": "Newsletter Subscription",
    "slug": "newsletter-subscription",
    "rating": 4.78,
    "votes": {
        "3": 3,
        "4": 3,
        "5": 35
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/newsletter-subscription/1653465598552.png",
    "__typename": "StockTemplate"
}, {
    "id": 1360,
    "name": "Cafe Invoice",
    "slug": "cafe-invoice",
    "rating": 4.5,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cafe-invoice/1657110473215.png",
    "__typename": "StockTemplate"
}, {
    "id": 1357,
    "name": "Stock Invoice",
    "slug": "stock-invoice",
    "rating": 4.77,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 3,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/stock-invoice/1651128876432.png",
    "__typename": "StockTemplate"
}, {
    "id": 1316,
    "name": "Consulting Service Invoice ",
    "slug": "consulting-service-invoice",
    "rating": 4.76,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 2,
        "4": 13,
        "5": 82
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/consulting-service-invoice/1651128185765.png",
    "__typename": "StockTemplate"
}, {
    "id": 1314,
    "name": "Mother's Day Cosmetics Sale",
    "slug": "mothers-day-cosmetics-sale",
    "rating": 4.04,
    "votes": {
        "1": 3,
        "2": 3,
        "3": 24,
        "4": 13,
        "5": 42
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mothers-day-cosmetics-sale/1650301612445.png",
    "__typename": "StockTemplate"
}, {
    "id": 1312,
    "name": "Mother's Day Shoes Sale",
    "slug": "mothers-day-shoes-sale",
    "rating": 4.43,
    "votes": {
        "1": 2,
        "2": 1,
        "4": 1,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mothers-day-shoes-sale/1650432984587.png",
    "__typename": "StockTemplate"
}, {
    "id": 1309,
    "name": "Mother's Day Appliance Sale",
    "slug": "mothers-day-appliance-sale",
    "rating": 4.56,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 2,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mothers-day-appliance-sale/1650433486891.png",
    "__typename": "StockTemplate"
}, {
    "id": 1308,
    "name": "Mother's Day Jewelry Sale",
    "slug": "mothers-day-jewelry-sale",
    "rating": 4.35,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 3,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mothers-day-jewelry-sale/1650433842591.png",
    "__typename": "StockTemplate"
}, {
    "id": 1307,
    "name": "Fashion Store Discount for Moms",
    "slug": "fashion-store-discount-for-moms",
    "rating": 4.45,
    "votes": {
        "1": 1,
        "3": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fashion-store-discount-for-moms/1650871204729.png",
    "__typename": "StockTemplate"
}, {
    "id": 1306,
    "name": "Appliances Purchase Invoice",
    "slug": "real-estate-commission-invoice",
    "rating": 4.65,
    "votes": {
        "1": 3,
        "2": 1,
        "4": 8,
        "5": 54
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/real-estate-commission-invoice/1651128434473.png",
    "__typename": "StockTemplate"
}, {
    "id": 1303,
    "name": "Christmas Party",
    "slug": "christmas-party",
    "rating": 4.77,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/christmas-party/1650871358346.png",
    "__typename": "StockTemplate"
}, {
    "id": 1302,
    "name": "Wedding invitation",
    "slug": "wedding-invitation",
    "rating": 4.75,
    "votes": {
        "4": 1,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/wedding-invitation/1651049032093.png",
    "__typename": "StockTemplate"
}, {
    "id": 1298,
    "name": "Spring Sale for Easter",
    "slug": "spring-sale-for-easter",
    "rating": 4.6,
    "votes": {
        "1": 3,
        "2": 1,
        "4": 8,
        "5": 45
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/spring-sale-for-easter/1649229096600.png",
    "__typename": "StockTemplate"
}, {
    "id": 1296,
    "name": "Best Recipes for Easter",
    "slug": "best-recipes-for-easter",
    "rating": 4.3,
    "votes": {
        "1": 2,
        "2": 4,
        "3": 3,
        "4": 2,
        "5": 29
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/best-recipes-for-easter/1649233381941.png",
    "__typename": "StockTemplate"
}, {
    "id": 1292,
    "name": "Hanukah Invitation",
    "slug": "hanukah-invitation",
    "rating": 4.79,
    "votes": {
        "3": 2,
        "4": 1,
        "5": 21
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hanukah-invitation/1650350635958.png",
    "__typename": "StockTemplate"
}, {
    "id": 1282,
    "name": "Finance Newsletter Re-Engagement Email Template",
    "slug": "Finance-newsletter-re-engagement-email-template",
    "rating": 4.84,
    "votes": {
        "2": 1,
        "4": 8,
        "5": 58
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/Finance-newsletter-re-engagement-email-template/1657017425221.png",
    "__typename": "StockTemplate"
}, {
    "id": 1281,
    "name": "Real estate newsletter re-engagement",
    "slug": "real-estate-newsletter-re-engagement",
    "rating": 4.75,
    "votes": {
        "3": 2,
        "4": 9,
        "5": 40
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/real-estate-newsletter-re-engagement/1650872742298.png",
    "__typename": "StockTemplate"
}, {
    "id": 1279,
    "name": "Subscription software re-engagement",
    "slug": "subscription-software-re-engagement",
    "rating": 4.75,
    "votes": {
        "2": 1,
        "3": 3,
        "4": 17,
        "5": 82
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/subscription-software-re-engagement/1650872866749.png",
    "__typename": "StockTemplate"
}, {
    "id": 1277,
    "name": "Clothing store re-engagement",
    "slug": "clothing-store-re-engagement",
    "rating": 4.15,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 5,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/clothing-store-re-engagement/1650872003748.png",
    "__typename": "StockTemplate"
}, {
    "id": 1276,
    "name": "Music Production Services Discount",
    "slug": "music-production-services-discount",
    "rating": 4.71,
    "votes": {
        "4": 5,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-production-services-discount/1650878262511.png",
    "__typename": "StockTemplate"
}, {
    "id": 1274,
    "name": "Music Day Studio Promotion",
    "slug": "music-day-studio-promotion",
    "rating": 4.75,
    "votes": {
        "4": 1,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-day-studio-promotion/1650880791472.png",
    "__typename": "StockTemplate"
}, {
    "id": 1258,
    "name": "Music School Admission Promotion",
    "slug": "music-school-admission-promotion",
    "rating": 3.95,
    "votes": {
        "1": 1,
        "2": 2,
        "3": 1,
        "4": 9,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-school-admission-promotion/1650883067485.png",
    "__typename": "StockTemplate"
}, {
    "id": 1253,
    "name": "Music Day Discount",
    "slug": "music-day-discount",
    "rating": 5,
    "votes": {
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-day-discount/1651211992374.png",
    "__typename": "StockTemplate"
}, {
    "id": 1249,
    "name": "Apology For Cancellation Of Meeting",
    "slug": "apology-for-cancellation-of-meeting",
    "rating": 4.3,
    "votes": {
        "1": 3,
        "4": 9,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-cancellation-of-meeting/1657003282785.png",
    "__typename": "StockTemplate"
}, {
    "id": 1246,
    "name": "Apology For Late Customer Response",
    "slug": "apology-for-late-customer-response",
    "rating": 4.75,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-late-customer-response/1657003334664.png",
    "__typename": "StockTemplate"
}, {
    "id": 1245,
    "name": "Apology For Not Attending Call",
    "slug": "apology-for-not-attending-call",
    "rating": 4.67,
    "votes": {
        "4": 4,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-not-attending-call/1657003463752.png",
    "__typename": "StockTemplate"
}, {
    "id": 1244,
    "name": "Apology To Boss For Mistake",
    "slug": "apology-to-boss-for-mistake",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-to-boss-for-mistake/1657003392346.png",
    "__typename": "StockTemplate"
}, {
    "id": 1210,
    "name": "Apology To Customer For Delay In Delivery",
    "slug": "apology-to-customer-for-delay-in-delivery",
    "rating": 4.83,
    "votes": {
        "4": 5,
        "5": 25
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-to-customer-for-delay-in-delivery/1657004015215.png",
    "__typename": "StockTemplate"
}, {
    "id": 1208,
    "name": "Apology to Fellow Colleague",
    "slug": "apology-to-fellow-colleague",
    "rating": 4.52,
    "votes": {
        "1": 3,
        "2": 2,
        "3": 5,
        "4": 18,
        "5": 68
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-to-fellow-colleague/1647809425584.png",
    "__typename": "StockTemplate"
}, {
    "id": 1205,
    "name": "Apology to Ecommerce Customer",
    "slug": "apology-to-ecommerce-customer",
    "rating": 4.36,
    "votes": {
        "1": 2,
        "2": 2,
        "3": 3,
        "4": 7,
        "5": 28
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-to-ecommerce-customer/1647810080697.png",
    "__typename": "StockTemplate"
}, {
    "id": 1200,
    "name": "Feedback For Electronics Customers",
    "slug": "feedback-for-electronics-customers",
    "rating": 4.49,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 3,
        "4": 14,
        "5": 41
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/feedback-for-electronics-customers/1647808384779.png",
    "__typename": "StockTemplate"
}, {
    "id": 1198,
    "name": "Feedback For Automotive Customers",
    "slug": "feedback-for-automotive-customers",
    "rating": 4.32,
    "votes": {
        "1": 4,
        "3": 4,
        "4": 1,
        "5": 28
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/feedback-for-automotive-customers/1647809327246.png",
    "__typename": "StockTemplate"
}, {
    "id": 1194,
    "name": "Feedback For Restaurant Customer Service",
    "slug": "feedback-for-restaurant-customer-service",
    "rating": 4.66,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 27
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/feedback-for-restaurant-customer-service/1647808741645.png",
    "__typename": "StockTemplate"
}, {
    "id": 1188,
    "name": "Apology to Automobile Customer",
    "slug": "apology-to-automobile-customer",
    "rating": 4.53,
    "votes": {
        "1": 1,
        "4": 5,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-to-automobile-customer/1647809192162.png",
    "__typename": "StockTemplate"
}, {
    "id": 1187,
    "name": "World Tourism Day Event Invitation",
    "slug": "world-tourism-day-event-invitation",
    "rating": 4.59,
    "votes": {
        "1": 3,
        "3": 2,
        "4": 7,
        "5": 44
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/world-tourism-day-event-invitation/1647809087727.png",
    "__typename": "StockTemplate"
}, {
    "id": 1185,
    "name": "Trekking Equipment Sale On Tourism Day",
    "slug": "trekking-equipment-sale-on-tourism-day",
    "rating": 4.17,
    "votes": {
        "1": 3,
        "2": 3,
        "4": 3,
        "5": 20
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/trekking-equipment-sale-on-tourism-day/1647808959961.png",
    "__typename": "StockTemplate"
}, {
    "id": 1183,
    "name": "Apology Email to Company Boss",
    "slug": "apology-email-to-company-boss",
    "rating": 4.52,
    "votes": {
        "1": 1,
        "2": 5,
        "3": 3,
        "4": 3,
        "5": 46
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-email-to-company-boss/1644874149048.png",
    "__typename": "StockTemplate"
}, {
    "id": 1181,
    "name": "Apology For Not Attending Meeting",
    "slug": "apology-for-not-attending-meeting",
    "rating": 3.97,
    "votes": {
        "1": 3,
        "2": 3,
        "3": 3,
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-not-attending-meeting/1644874812994.png",
    "__typename": "StockTemplate"
}, {
    "id": 1179,
    "name": "Apology For Sending Wrong Email",
    "slug": "apology-for-sending-wrong-email",
    "rating": 4.6,
    "votes": {
        "1": 7,
        "2": 6,
        "3": 13,
        "4": 45,
        "5": 225
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-sending-wrong-email/1644874973110.png",
    "__typename": "StockTemplate"
}, {
    "id": 1178,
    "name": "Vacation Tour Discount On Tourism Day",
    "slug": "vacation-tour-discount-on-tourism-day",
    "rating": 4.92,
    "votes": {
        "4": 1,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/vacation-tour-discount-on-tourism-day/1647808290413.png",
    "__typename": "StockTemplate"
}, {
    "id": 1176,
    "name": "Apology For Late Payment To Supplier",
    "slug": "apology-for-late-payment-to-supplier",
    "rating": 4.54,
    "votes": {
        "1": 4,
        "2": 3,
        "3": 5,
        "4": 18,
        "5": 86
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-late-payment-to-supplier/1644875148128.png",
    "__typename": "StockTemplate"
}, {
    "id": 1172,
    "name": "Apology For Not Attending Interview",
    "slug": "apology-for-not-attending-interview",
    "rating": 4.41,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 4,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-for-not-attending-interview/1644878653301.png",
    "__typename": "StockTemplate"
}, {
    "id": 1163,
    "name": "Formal Business Apology",
    "slug": "formal-business-apology",
    "rating": 4.67,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 4,
        "4": 11,
        "5": 63
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/formal-business-apology/1644877769985.png",
    "__typename": "StockTemplate"
}, {
    "id": 1161,
    "name": "Proof Of Product Delivery",
    "slug": "proof-of-product-delivery",
    "rating": 4.78,
    "votes": {
        "2": 1,
        "4": 5,
        "5": 31
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/proof-of-product-delivery/1644878452187.png",
    "__typename": "StockTemplate"
}, {
    "id": 1160,
    "name": "Food Items Delivery Notification",
    "slug": "food-items-delivery-notification",
    "rating": 4.85,
    "votes": {
        "3": 1,
        "4": 8,
        "5": 56
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/food-items-delivery-notification/1647805905486.png",
    "__typename": "StockTemplate"
}, {
    "id": 1159,
    "name": "Product Delivery Update",
    "slug": "product-delivery-update",
    "rating": 4.57,
    "votes": {
        "1": 2,
        "2": 2,
        "3": 2,
        "4": 13,
        "5": 53
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/product-delivery-update/1644878380139.png",
    "__typename": "StockTemplate"
}, {
    "id": 1156,
    "name": "Delivery Confirmation Email",
    "slug": "delivery-confirmation-email",
    "rating": 4.63,
    "votes": {
        "2": 2,
        "3": 5,
        "4": 14,
        "5": 60
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/delivery-confirmation-email/1644878023876.png",
    "__typename": "StockTemplate"
}, {
    "id": 1155,
    "name": "Business Service Delivery Details",
    "slug": "business-service-delivery-details",
    "rating": 4.65,
    "votes": {
        "1": 11,
        "2": 7,
        "3": 12,
        "4": 62,
        "5": 335
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/business-service-delivery-details/1641748544205.png",
    "__typename": "StockTemplate"
}, {
    "id": 1154,
    "name": "Project Delivery Details",
    "slug": "project-delivery-details",
    "rating": 4.68,
    "votes": {
        "1": 1,
        "2": 3,
        "3": 4,
        "4": 19,
        "5": 99
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/project-delivery-details/1641747806504.png",
    "__typename": "StockTemplate"
}, {
    "id": 1153,
    "name": "Social Media Event Promotion",
    "slug": "social-media-event-promotion",
    "rating": 4.86,
    "votes": {
        "4": 2,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/social-media-event-promotion/1647809008521.png",
    "__typename": "StockTemplate"
}, {
    "id": 1151,
    "name": "Online Event Promotion",
    "slug": "online-event-promotion",
    "rating": 4.36,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-event-promotion/1647805736452.png",
    "__typename": "StockTemplate"
}, {
    "id": 1145,
    "name": "Delay In Order Delivery",
    "slug": "delay-in-order-delivery",
    "rating": 4.78,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 2,
        "4": 13,
        "5": 107
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/delay-in-order-delivery/1641744037953.png",
    "__typename": "StockTemplate"
}, {
    "id": 1144,
    "name": "CV Referral for Employment ",
    "slug": "cv-referral-for-employment",
    "rating": 4.85,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cv-referral-for-employment/1647807845969.png",
    "__typename": "StockTemplate"
}, {
    "id": 1138,
    "name": "Client Background Verification",
    "slug": "client-background-verification",
    "rating": 4.62,
    "votes": {
        "1": 5,
        "2": 1,
        "3": 6,
        "4": 25,
        "5": 120
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/client-background-verification/1641742234815.png",
    "__typename": "StockTemplate"
}, {
    "id": 1136,
    "name": "Appointment Verification Request",
    "slug": "apointment-verification-request",
    "rating": 4.7,
    "votes": {
        "1": 1,
        "2": 2,
        "3": 7,
        "4": 10,
        "5": 93
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apointment-verification-request/1644876233781.png",
    "__typename": "StockTemplate"
}, {
    "id": 1135,
    "name": "Education Verification",
    "slug": "education-verification",
    "rating": 4.66,
    "votes": {
        "1": 5,
        "2": 5,
        "4": 9,
        "5": 112
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/education-verification/1641737756563.png",
    "__typename": "StockTemplate"
}, {
    "id": 1134,
    "name": "Employee Background Verification",
    "slug": "employee-background-verification",
    "rating": 4.77,
    "votes": {
        "1": 1,
        "3": 3,
        "4": 17,
        "5": 98
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/employee-background-verification/1644877919464.png",
    "__typename": "StockTemplate"
}, {
    "id": 529,
    "name": "Thanksgiving Deals",
    "slug": "thanksgiving-deals",
    "rating": 4.49,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 5,
        "4": 4,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/thanksgiving-deals/1631071101602.png",
    "__typename": "StockTemplate"
}, {
    "id": 884,
    "name": "Thanksgiving Special Furniture Sale",
    "slug": "thanksgiving-special-furniture-sale",
    "rating": 4.55,
    "votes": {
        "1": 3,
        "2": 1,
        "3": 5,
        "4": 30,
        "5": 84
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/thanksgiving-special-furniture-sale/1632084415949.png",
    "__typename": "StockTemplate"
}, {
    "id": 873,
    "name": "Thanksgiving Footwear Sale",
    "slug": "thanksgiving-footwear-sale",
    "rating": 4.75,
    "votes": {
        "1": 4,
        "3": 1,
        "4": 22,
        "5": 132
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/thanksgiving-footwear-sale/1632084688376.png",
    "__typename": "StockTemplate"
}, {
    "id": 888,
    "name": "Thanksgiving Hotel Discount",
    "slug": "thanksgiving-hotel-discount",
    "rating": 4.38,
    "votes": {
        "1": 3,
        "2": 2,
        "3": 3,
        "4": 8,
        "5": 36
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/thanksgiving-hotel-discount/1632085185159.png",
    "__typename": "StockTemplate"
}, {
    "id": 1099,
    "name": "Employment Verification",
    "slug": "employment-verification",
    "rating": 4.67,
    "votes": {
        "1": 3,
        "2": 1,
        "3": 4,
        "4": 11,
        "5": 83
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/employment-verification/1641742070060.png",
    "__typename": "StockTemplate"
}, {
    "id": 1098,
    "name": "Car Sales Referral",
    "slug": "car-sales-referral",
    "rating": 4.62,
    "votes": {
        "4": 5,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/car-sales-referral/1647805570575.png",
    "__typename": "StockTemplate"
}, {
    "id": 1094,
    "name": "B2B Sales Referral",
    "slug": "b2b-sales-referral",
    "rating": 4.76,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/b2b-sales-referral/1644876012040.png",
    "__typename": "StockTemplate"
}, {
    "id": 1093,
    "name": "Generic Business Referral",
    "slug": "generic-business-referral",
    "rating": 4.9,
    "votes": {
        "4": 2,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/generic-business-referral/1647807118306.png",
    "__typename": "StockTemplate"
}, {
    "id": 1091,
    "name": "Client Acquisition Referral for Business",
    "slug": "client-acquisition-referral-for-business",
    "rating": 4.89,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 26
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/client-acquisition-referral-for-business/1638712384634.png",
    "__typename": "StockTemplate"
}, {
    "id": 1090,
    "name": "Employees Hiring Referral Bonus",
    "slug": "employees-hiring-referral-bonus",
    "rating": 4.9,
    "votes": {
        "4": 2,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/employees-hiring-referral-bonus/1638712043225.png",
    "__typename": "StockTemplate"
}, {
    "id": 1086,
    "name": "HR Interview Referral",
    "slug": "hr-interview-referral",
    "rating": 4.72,
    "votes": {
        "1": 2,
        "2": 2,
        "3": 2,
        "4": 13,
        "5": 92
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hr-interview-referral/1638711831617.png",
    "__typename": "StockTemplate"
}, {
    "id": 1078,
    "name": "Restaurant Bad Service Apology",
    "slug": "restaurant-bad-service-apology",
    "rating": 4.73,
    "votes": {
        "1": 1,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/restaurant-bad-service-apology/1641741859369.png",
    "__typename": "StockTemplate"
}, {
    "id": 1073,
    "name": "Meditation Day Chiropractor Promotion",
    "slug": "meditation-day-chiropractor-promotion",
    "rating": 4.75,
    "votes": {
        "3": 2,
        "4": 10,
        "5": 43
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/meditation-day-chiropractor-promotion/1638098460992.png",
    "__typename": "StockTemplate"
}, {
    "id": 825,
    "name": "Halloween Lights Discount",
    "slug": "halloween-lights-discount",
    "rating": 4.32,
    "votes": {
        "1": 1,
        "3": 5,
        "4": 1,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-lights-discount/1628350372128.png",
    "__typename": "StockTemplate"
}, {
    "id": 882,
    "name": "Halloween Bouquet Sale",
    "slug": "halloween-bouquet-sale",
    "rating": 4.47,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 3,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-bouquet-sale/1630194183384.png",
    "__typename": "StockTemplate"
}, {
    "id": 881,
    "name": "Halloween Pets Treat Discount",
    "slug": "halloween-pets-treat-discount",
    "rating": 4.48,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 4,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-pets-treat-discount/1632700220322.png",
    "__typename": "StockTemplate"
}, {
    "id": 880,
    "name": "Halloween Special Jewellery Collection",
    "slug": "halloween-special-jewellery-collection",
    "rating": 4.45,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-special-jewellery-collection/1632699893262.png",
    "__typename": "StockTemplate"
}, {
    "id": 879,
    "name": "Halloween Gadgets Sale",
    "slug": "halloween-gadgets-sale",
    "rating": 4.65,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 5,
        "5": 27
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-gadgets-sale/1630194062861.png",
    "__typename": "StockTemplate"
}, {
    "id": 883,
    "name": "Halloween Celebration Announcement",
    "slug": "halloween-celebration-announcement",
    "rating": 4.26,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 2,
        "4": 3,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-celebration-announcement/1632697419677.png",
    "__typename": "StockTemplate"
}, {
    "id": 1069,
    "name": "Event Space On Friendship Day",
    "slug": "event-space-on-friendship-day",
    "rating": 5,
    "votes": {
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/event-space-on-friendship-day/1644876379849.png",
    "__typename": "StockTemplate"
},{
    "id": 825,
    "name": "Halloween Lights Discount",
    "slug": "halloween-lights-discount",
    "rating": 4.32,
    "votes": {
        "1": 1,
        "3": 5,
        "4": 1,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-lights-discount/1628350372128.png",
    "__typename": "StockTemplate"
}, {
    "id": 883,
    "name": "Halloween Celebration Announcement",
    "slug": "halloween-celebration-announcement",
    "rating": 4.26,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 2,
        "4": 3,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/halloween-celebration-announcement/1632697419677.png",
    "__typename": "StockTemplate"
}, {
    "id": 1069,
    "name": "Event Space On Friendship Day",
    "slug": "event-space-on-friendship-day",
    "rating": 5,
    "votes": {
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/event-space-on-friendship-day/1644876379849.png",
    "__typename": "StockTemplate"
}, {
    "id": 1067,
    "name": "Friendship Day  Jewellery Sale",
    "slug": "friendship-day-jewellery-sale",
    "rating": 5,
    "votes": {
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/friendship-day-jewellery-sale/1638063782373.png",
    "__typename": "StockTemplate"
}, {
    "id": 1055,
    "name": "Women’s Day Company Announcement",
    "slug": "womens-day-company-announcement",
    "rating": 4.75,
    "votes": {
        "4": 3,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-company-announcement/1638053436176.png",
    "__typename": "StockTemplate"
}, {
    "id": 1048,
    "name": "Women’s Day March Announcement",
    "slug": "womens-day-march-announcement",
    "rating": 5,
    "votes": {
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-march-announcement/1638028305217.png",
    "__typename": "StockTemplate"
}, {
    "id": 1045,
    "name": "Women’s Day Corporate Event Announcement",
    "slug": "womens-day-corporate-event-announcement",
    "rating": 4.78,
    "votes": {
        "4": 2,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-corporate-event-announcement/1638026181105.png",
    "__typename": "StockTemplate"
}, {
    "id": 1044,
    "name": "Women’s Day Restaurant Discount ",
    "slug": "womens-day-restaurant-discount",
    "rating": 4.75,
    "votes": {
        "4": 2,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-restaurant-discount/1638026083485.png",
    "__typename": "StockTemplate"
}, {
    "id": 1032,
    "name": "Giving Charity For Each Water Bottle Sold",
    "slug": "giving-charity-for-each-water-bottle-sold",
    "rating": 4.81,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/giving-charity-for-each-water-bottle-sold/1641739279372.png",
    "__typename": "StockTemplate"
}, {
    "id": 1030,
    "name": "Water Day Awareness Event Invitation ",
    "slug": "water-day-awareness-event-invitation",
    "rating": 4.89,
    "votes": {
        "4": 2,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/water-day-awareness-event-invitation/1641738774761.png",
    "__typename": "StockTemplate"
}, {
    "id": 1029,
    "name": "Skin Care Earth Day Discount",
    "slug": "skin-care-earth-day-discount",
    "rating": 4.11,
    "votes": {
        "1": 1,
        "3": 8,
        "4": 5,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/skin-care-earth-day-discount/1638046609666.png",
    "__typename": "StockTemplate"
}, {
    "id": 1028,
    "name": "World Water Crisis Awareness",
    "slug": "world-water-crisis-awareness",
    "rating": 4.68,
    "votes": {
        "3": 1,
        "4": 4,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/world-water-crisis-awareness/1641738631198.png",
    "__typename": "StockTemplate"
}, {
    "id": 1024,
    "name": "Clean Water NGO Promotion",
    "slug": "clean-water-ngo-promotion",
    "rating": 4.6,
    "votes": {
        "1": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/clean-water-ngo-promotion/1641738396858.png",
    "__typename": "StockTemplate"
}, {
    "id": 1023,
    "name": "Support Clean Water Drive",
    "slug": "support-clean-water-drive",
    "rating": 4.75,
    "votes": {
        "4": 4,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/support-clean-water-drive/1641738061683.png",
    "__typename": "StockTemplate"
}, {
    "id": 1020,
    "name": "Fundraising For Clean Water",
    "slug": "fundraising-for-clean-water",
    "rating": 4.75,
    "votes": {
        "4": 3,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fundraising-for-clean-water/1637279332030.png",
    "__typename": "StockTemplate"
}, {
    "id": 1019,
    "name": "Women’s Day Gadgets Sale",
    "slug": "womens-day-gadgets-sale",
    "rating": 4.88,
    "votes": {
        "4": 1,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-gadgets-sale/1637279223932.png",
    "__typename": "StockTemplate"
}, {
    "id": 1016,
    "name": "Women’s Day Jewellery Sale",
    "slug": "womens-day-jewellery-sale",
    "rating": 4.54,
    "votes": {
        "3": 2,
        "4": 2,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-jewellery-sale/1637279039100.png",
    "__typename": "StockTemplate"
}, {
    "id": 1015,
    "name": "Vegan Restaurants Earth Day Special",
    "slug": "vegan-restaurants-earth-day-special",
    "rating": 4.5,
    "votes": {
        "4": 2,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/vegan-restaurants-earth-day-special/1641737856528.png",
    "__typename": "StockTemplate"
}, {
    "id": 1014,
    "name": "Women’s Day Cosmetics Sale",
    "slug": "womens-day-cosmetics-sale",
    "rating": 4.92,
    "votes": {
        "4": 2,
        "5": 22
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-cosmetics-sale/1637278953931.png",
    "__typename": "StockTemplate"
}, {
    "id": 1013,
    "name": "Fundraising For Earth Day",
    "slug": "fundraising-for-earth-day",
    "rating": 4.9,
    "votes": {
        "4": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fundraising-for-earth-day/1637278896454.png",
    "__typename": "StockTemplate"
}, {
    "id": 1010,
    "name": "Earth Day Clothing Sale",
    "slug": "earth-day-clothing-sale",
    "rating": 4.91,
    "votes": {
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/earth-day-clothing-sale/1638098352251.png",
    "__typename": "StockTemplate"
}, {
    "id": 1006,
    "name": "Art Day Invitation for Kindergarteners",
    "slug": "art-day-invitation-for-kindergarteners",
    "rating": 4,
    "votes": {
        "4": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/art-day-invitation-for-kindergarteners/1650355626096.png",
    "__typename": "StockTemplate"
}, {
    "id": 972,
    "name": "Guitar Center Martin Luther King Jr. Day",
    "slug": "guitar-center-martin-luther-king-jr-day",
    "rating": 4.88,
    "votes": {
        "3": 1,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/guitar-center-martin-luther-king-jr-day/1637022020043.png",
    "__typename": "StockTemplate"
}, {
    "id": 971,
    "name": "Martin Luther King Jr. Day Furniture Sale",
    "slug": "martin-luther-king-jr-day-furniture-sale",
    "rating": 3.8,
    "votes": {
        "3": 3,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/martin-luther-king-jr-day-furniture-sale/1637021883038.png",
    "__typename": "StockTemplate"
}, {
    "id": 968,
    "name": "Black History Month Trivia Announcement",
    "slug": "black-history-month-trivia-announcement",
    "rating": 4.72,
    "votes": {
        "4": 5,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-history-month-trivia-announcement/1637021488395.png",
    "__typename": "StockTemplate"
}, {
    "id": 967,
    "name": "Black History Month Middle School Activities",
    "slug": "black-history-month-middle-school-activities",
    "rating": 4.96,
    "votes": {
        "4": 1,
        "5": 25
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-history-month-middle-school-activities/1637021422241.png",
    "__typename": "StockTemplate"
}, {
    "id": 963,
    "name": "Black History Month Activities for College Students",
    "slug": "black-history-month-activities-for-college-students",
    "rating": 4.7,
    "votes": {
        "4": 9,
        "5": 21
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-history-month-activities-for-college-students/1637020931543.png",
    "__typename": "StockTemplate"
}, {
    "id": 962,
    "name": "Art Day Discount On Art Work",
    "slug": "art-day-discount-on-art-work",
    "rating": 4.25,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/art-day-discount-on-art-work/1637278630503.png",
    "__typename": "StockTemplate"
}, {
    "id": 961,
    "name": "Black History Month Celebration Invitation",
    "slug": "black-history-month-celebration-invitation",
    "rating": 4.75,
    "votes": {
        "4": 1,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-history-month-celebration-invitation/1650350724686.png",
    "__typename": "StockTemplate"
}, {
    "id": 960,
    "name": "Black History Month March Announcement",
    "slug": "black-history-month-march-announcement",
    "rating": 5,
    "votes": {
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-history-month-march-announcement/1637020080745.png",
    "__typename": "StockTemplate"
}, {
    "id": 955,
    "name": "Art Day Sale On Art Supplies",
    "slug": "art-day-sale-on-art-supplies",
    "rating": 5,
    "votes": {
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/art-day-sale-on-art-supplies/1637278491453.png",
    "__typename": "StockTemplate"
}, {
    "id": 953,
    "name": "Art Day Event Invitation",
    "slug": "art-day-event-invitation",
    "rating": null,
    "votes": {},
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/art-day-event-invitation/1650355270245.png",
    "__typename": "StockTemplate"
}, {
    "id": 952,
    "name": "Support Cancer Research",
    "slug": "support-cancer-research",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/support-cancer-research/1637278364995.png",
    "__typename": "StockTemplate"
}, {
    "id": 949,
    "name": "Fundraising Drive For Cancer Day",
    "slug": "fundraising-drive-for-cancer-day",
    "rating": 4.91,
    "votes": {
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fundraising-drive-for-cancer-day/1637278176413.png",
    "__typename": "StockTemplate"
}, {
    "id": 948,
    "name": "Memorial Day Forever In Our Hearts",
    "slug": "memorial-day-forever-in-our-hearts",
    "rating": 4.37,
    "votes": {
        "4": 12,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-forever-in-our-hearts/1637019691663.png",
    "__typename": "StockTemplate"
}, {
    "id": 946,
    "name": "Memorial Day Message",
    "slug": "memorial-day-message",
    "rating": null,
    "votes": {},
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-message/1658299013857.png",
    "__typename": "StockTemplate"
}, {
    "id": 944,
    "name": "Memorial Day Fashion Sale",
    "slug": "memorial-day-fashion-sale",
    "rating": 5,
    "votes": {
        "5": 22
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-fashion-sale/1637019170722.png",
    "__typename": "StockTemplate"
}, {
    "id": 943,
    "name": "Donate for Cancer",
    "slug": "donate-for-cancer",
    "rating": 5,
    "votes": {
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/donate-for-cancer/1637278071154.png",
    "__typename": "StockTemplate"
}, {
    "id": 939,
    "name": "Memorial Day Deserts Discount",
    "slug": "memorial-day-deserts-discount",
    "rating": 3.83,
    "votes": {
        "1": 1,
        "2": 2,
        "3": 1,
        "4": 2,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-deserts-discount/1634989922213.png",
    "__typename": "StockTemplate"
}, {
    "id": 937,
    "name": "Memorial Day Goggles Discount",
    "slug": "memorial-day-goggles-discount",
    "rating": 4.31,
    "votes": {
        "3": 2,
        "4": 5,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-goggles-discount/1634989800316.png",
    "__typename": "StockTemplate"
}, {
    "id": 933,
    "name": "Memorial Day Automotive Sale",
    "slug": "memorial-day-automotive-sale",
    "rating": 4.35,
    "votes": {
        "1": 3,
        "2": 2,
        "4": 14,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-automotive-sale/1632701528014.png",
    "__typename": "StockTemplate"
}, {
    "id": 932,
    "name": "Memorial Day Appliances Sale",
    "slug": "memorial-day-appliances-sale",
    "rating": 5,
    "votes": {
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/memorial-day-appliances-sale/1637019244316.png",
    "__typename": "StockTemplate"
}, {
    "id": 929,
    "name": "LGBTQ Jewellery Sale",
    "slug": "lgbtq-jewellery-sale",
    "rating": 4.63,
    "votes": {
        "1": 3,
        "4": 5,
        "5": 38
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/lgbtq-jewellery-sale/1632701261418.png",
    "__typename": "StockTemplate"
}, {
    "id": 926,
    "name": "Pride Month Parade Invitation",
    "slug": "pride-month-parade-invitation",
    "rating": 4.79,
    "votes": {
        "3": 1,
        "4": 4,
        "5": 24
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/pride-month-parade-invitation/1650355712412.png",
    "__typename": "StockTemplate"
}, {
    "id": 921,
    "name": "LGBTQ Parade Announcement",
    "slug": "lgbtq-parade-announcement",
    "rating": 4,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/lgbtq-parade-announcement/1634987944387.png",
    "__typename": "StockTemplate"
}, {
    "id": 920,
    "name": "Pride Month Makeup Brand Promotion",
    "slug": "pride-month-makeup-brand-promotion",
    "rating": 4.85,
    "votes": {
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/pride-month-makeup-brand-promotion/1632700694836.png",
    "__typename": "StockTemplate"
}, {
    "id": 919,
    "name": "Pride Month Cosmetics Discount",
    "slug": "pride-month-cosmetics-discount",
    "rating": 5,
    "votes": {
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/pride-month-cosmetics-discount/1634987175477.png",
    "__typename": "StockTemplate"
}, {
    "id": 917,
    "name": "Cyber Monday Cosmetics Sale",
    "slug": "cyber-monday-cosmetics-sale",
    "rating": 4,
    "votes": {
        "1": 2,
        "2": 2,
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-cosmetics-sale/1632700375357.png",
    "__typename": "StockTemplate"
}, {
    "id": 916,
    "name": "Cyber Monday Tourism Trip Discount",
    "slug": "cyber-monday-tourism-trip-discount",
    "rating": 4.46,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 6,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-tourism-trip-discount/1632700308934.png",
    "__typename": "StockTemplate"
}, {
    "id": 913,
    "name": "Cyber Monday Super Automotive Sale",
    "slug": "cyber-monday-super-automotive-sale",
    "rating": 4.71,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 20
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-super-automotive-sale/1632699108367.png",
    "__typename": "StockTemplate"
}, {
    "id": 910,
    "name": "Cyber Monday Fashion Winter Collection",
    "slug": "cyber-monday-fashion-winter-collection",
    "rating": 5,
    "votes": {
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-fashion-winter-collection/1632698538933.png",
    "__typename": "StockTemplate"
}, {
    "id": 906,
    "name": " Columbus Day Sale For Furniture",
    "slug": "columbus-day-sale-for-furniture",
    "rating": 4.68,
    "votes": {
        "3": 2,
        "4": 2,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/columbus-day-sale-for-furniture/1630852433359.png",
    "__typename": "StockTemplate"
}, {
    "id": 904,
    "name": "Super Bowl Beer Store Promotion",
    "slug": "super-bowl-beer-store-promotion",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/super-bowl-beer-store-promotion/1632698291211.png",
    "__typename": "StockTemplate"
}, {
    "id": 903,
    "name": "Super Bowl Football Equipment Sale",
    "slug": "super-bowl-football-equipment-sale",
    "rating": 4.11,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/super-bowl-football-equipment-sale/1632698146066.png",
    "__typename": "StockTemplate"
}, {
    "id": 902,
    "name": "Super Bowl Live Streaming",
    "slug": "super-bowl-live-streaming",
    "rating": 4.93,
    "votes": {
        "4": 1,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/super-bowl-live-streaming/1632698038153.png",
    "__typename": "StockTemplate"
}, {
    "id": 900,
    "name": "Cyber Monday Tech Gadgets Sale",
    "slug": "cyber-monday-tech-gadgets-sale",
    "rating": 4.81,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-tech-gadgets-sale/1632697828005.png",
    "__typename": "StockTemplate"
}, {
    "id": 895,
    "name": "Labor Day Discount For Tourism",
    "slug": "labor-day-discount-for-tourism",
    "rating": 4.07,
    "votes": {
        "1": 1,
        "3": 3,
        "4": 4,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/labor-day-discount-for-tourism/1630852021309.png",
    "__typename": "StockTemplate"
}, {
    "id": 894,
    "name": "Super Bowl Sports Goods Discount ",
    "slug": "super-bowl-sports-goods-discount",
    "rating": 4.85,
    "votes": {
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/super-bowl-sports-goods-discount/1632697605332.png",
    "__typename": "StockTemplate"
}, {
    "id": 893,
    "name": "Newsletter for Business Consulting",
    "slug": "newsletter-for-business-consulting",
    "rating": 4.91,
    "votes": {
        "4": 3,
        "5": 32
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/newsletter-for-business-consulting/1632697495686.png",
    "__typename": "StockTemplate"
}, {
    "id": 889,
    "name": "Veterans Day Remembering Heroes",
    "slug": "veterans-day-remembering-heroes",
    "rating": 4.46,
    "votes": {
        "3": 4,
        "4": 6,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/veterans-day-remembering-heroes/1630851810344.png",
    "__typename": "StockTemplate"
}, {
    "id": 878,
    "name": "Presidents’ Day Holiday Announcement ",
    "slug": "presidents-day-holiday-announcement",
    "rating": 4.89,
    "votes": {
        "4": 2,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-holiday-announcement/1632697046498.png",
    "__typename": "StockTemplate"
}, {
    "id": 876,
    "name": "Presidents’ Day Sale Kitchen Appliances",
    "slug": "presidents-day-sale-kitchen-appliances",
    "rating": 5,
    "votes": {
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-sale-kitchen-appliances/1632700126429.png",
    "__typename": "StockTemplate"
}, {
    "id": 874,
    "name": "Presidents’ Day Sale Jewelry",
    "slug": "presidents-day-sale-jewelry",
    "rating": 4.93,
    "votes": {
        "3": 1,
        "5": 27
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-sale-jewelry/1632695466799.png",
    "__typename": "StockTemplate"
}, {
    "id": 869,
    "name": "Presidents’ Day Toys Sale",
    "slug": "presidents-day-toys-sale",
    "rating": 4.92,
    "votes": {
        "4": 1,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-toys-sale/1632699559234.png",
    "__typename": "StockTemplate"
}, {
    "id": 867,
    "name": "Presidents’ Day Smart Watch Sale",
    "slug": "presidents-day-smart-watch-sale",
    "rating": 4.45,
    "votes": {
        "3": 3,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-smart-watch-sale/1632695331788.png",
    "__typename": "StockTemplate"
}, {
    "id": 866,
    "name": "Veterans Day Gadgets Sale",
    "slug": "veterans-day-gadgets-sale",
    "rating": 5,
    "votes": {
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/veterans-day-gadgets-sale/1630800336683.png",
    "__typename": "StockTemplate"
}, {
    "id": 865,
    "name": "Boxing Day Gym Membership Discount",
    "slug": "boxing-day-gym-membership-discount",
    "rating": 4.93,
    "votes": {
        "4": 1,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/boxing-day-gym-membership-discount/1630193768814.png",
    "__typename": "StockTemplate"
}, {
    "id": 864,
    "name": "Boxing Day Fitness Costumes sale",
    "slug": "boxing-day-fitness-costumes-sale",
    "rating": 4.72,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/boxing-day-fitness-costumes-sale/1630193670060.png",
    "__typename": "StockTemplate"
}, {
    "id": 862,
    "name": "Boxing Equipment On Boxing Day ",
    "slug": "boxing-equipment-on-boxing-day",
    "rating": 4.76,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/boxing-equipment-on-boxing-day/1630193569598.png",
    "__typename": "StockTemplate"
}, {
    "id": 861,
    "name": "Presidents’ Day Laptops Sale ",
    "slug": "presidents-day-laptops-sale",
    "rating": 4.7,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-laptops-sale/1630154321929.png",
    "__typename": "StockTemplate"
}, {
    "id": 860,
    "name": "Presidents’ Day Furniture Sale",
    "slug": "presidents-day-furniture-sale",
    "rating": 5,
    "votes": {
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-furniture-sale/1630193423627.png",
    "__typename": "StockTemplate"
}, {
    "id": 859,
    "name": "Presidents’ Day Electronics Sale",
    "slug": "presidents-day-electronics-sale",
    "rating": 3.9,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-electronics-sale/1630154497360.png",
    "__typename": "StockTemplate"
}, {
    "id": 858,
    "name": "Presidents’ Day New Fashion Arrival",
    "slug": "presidents-day-new-fashion-arrival",
    "rating": 3.5,
    "votes": {
        "1": 1,
        "4": 2,
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/presidents-day-new-fashion-arrival/1630154418923.png",
    "__typename": "StockTemplate"
}, {
    "id": 857,
    "name": "Easter Prayer Announcement",
    "slug": "easter-prayer-announcement",
    "rating": 4.25,
    "votes": {
        "2": 3,
        "3": 2,
        "4": 5,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-prayer-announcement/1629664246093.png",
    "__typename": "StockTemplate"
}, {
    "id": 854,
    "name": "Easter Discount for Beverages ",
    "slug": "easter-discount-for-beverages",
    "rating": 4.33,
    "votes": {
        "1": 1,
        "4": 4,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-discount-for-beverages/1629663616693.png",
    "__typename": "StockTemplate"
}, {
    "id": 852,
    "name": "Easter Special Jewelry Collection",
    "slug": "easter-special-jewelry-collection",
    "rating": 4.8,
    "votes": {
        "4": 3,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-special-jewelry-collection/1629663022359.png",
    "__typename": "StockTemplate"
}, {
    "id": 851,
    "name": "Easter Sale on Furniture",
    "slug": "easter-sale-on-furniture",
    "rating": 4.72,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 21
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-sale-on-furniture/1629662095240.png",
    "__typename": "StockTemplate"
}, {
    "id": 850,
    "name": "Easter Sale on Clothes",
    "slug": "easter-sale-on-clothes",
    "rating": 4.24,
    "votes": {
        "1": 2,
        "2": 1,
        "4": 2,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-sale-on-clothes/1629661884892.png",
    "__typename": "StockTemplate"
}, {
    "id": 847,
    "name": "Easter Sale on Electronics",
    "slug": "easter-sale-on-electronics",
    "rating": 3.67,
    "votes": {
        "1": 3,
        "4": 4,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-sale-on-electronics/1629661135578.png",
    "__typename": "StockTemplate"
}, {
    "id": 842,
    "name": "Boxing Day Furniture Sale",
    "slug": "boxing-day-furniture-sale",
    "rating": 4.45,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 8,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/boxing-day-furniture-sale/1629660242281.png",
    "__typename": "StockTemplate"
}, {
    "id": 841,
    "name": "Back to School Dress Offer",
    "slug": "back-to-school-dress-offer",
    "rating": 4.14,
    "votes": {
        "1": 1,
        "3": 1,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/back-to-school-dress-offer/1657706791624.png",
    "__typename": "StockTemplate"
}, {
    "id": 837,
    "name": "Easter Egg Hunt Sports",
    "slug": "easter-egg-hunt-sports",
    "rating": 4.41,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 7,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-egg-hunt-sports/1629658913652.png",
    "__typename": "StockTemplate"
}, {
    "id": 836,
    "name": "Easter Fashion Sale",
    "slug": "easter-fashion-sale",
    "rating": 4.29,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 7,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/easter-fashion-sale/1629657953373.png",
    "__typename": "StockTemplate"
}, {
    "id": 827,
    "name": "Curriculum Vitae",
    "slug": "curriculum-vitae",
    "rating": 4.25,
    "votes": {
        "1": 1,
        "4": 2,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/curriculum-vitae/1628351495962.png",
    "__typename": "StockTemplate"
}, {
    "id": 826,
    "name": "Customers Feedback Request",
    "slug": "customers-feedback-request",
    "rating": 4.72,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 2,
        "4": 8,
        "5": 69
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/customers-feedback-request/1628351076508.png",
    "__typename": "StockTemplate"
}, {
    "id": 823,
    "name": "Mobile App Launch Announcement",
    "slug": "mobile-app-launch-announcement",
    "rating": 4.5,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 8,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mobile-app-launch-announcement/1628350185614.png",
    "__typename": "StockTemplate"
}, {
    "id": 822,
    "name": "Banking Credit Card Experience",
    "slug": "banking-credit-card-experience",
    "rating": 4.61,
    "votes": {
        "2": 2,
        "3": 1,
        "4": 4,
        "5": 24
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/banking-credit-card-experience/1628350096324.png",
    "__typename": "StockTemplate"
}, {
    "id": 821,
    "name": "Unlocking Brand Potential",
    "slug": "unlocking-brand-potential",
    "rating": 4.65,
    "votes": {
        "1": 2,
        "3": 2,
        "4": 7,
        "5": 44
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/unlocking-brand-potential/1627747637304.png",
    "__typename": "StockTemplate"
}, {
    "id": 820,
    "name": "A Country For Every Citizen",
    "slug": "a-country-for-every-citizen",
    "rating": 4.29,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/a-country-for-every-citizen/1628349881260.png",
    "__typename": "StockTemplate"
}, {
    "id": 819,
    "name": "Donation for Humanity",
    "slug": "donation-for-humanity",
    "rating": 4.58,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/donation-for-humanity/1628349042625.png",
    "__typename": "StockTemplate"
}, {
    "id": 818,
    "name": "Complete Account Setup Reminder",
    "slug": "complete-account-setup-reminder",
    "rating": 4.63,
    "votes": {
        "1": 3,
        "4": 6,
        "5": 39
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/complete-account-setup-reminder/1655955091797.png",
    "__typename": "StockTemplate"
}, {
    "id": 817,
    "name": "You Just Received Money!",
    "slug": "you-just-received-money",
    "rating": 4.57,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 14,
        "5": 31
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/you-just-received-money/1628347532444.png",
    "__typename": "StockTemplate"
}, {
    "id": 813,
    "name": "Personal Development Mentor ",
    "slug": "personal-development-mentor",
    "rating": 4.5,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 3,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/personal-development-mentor/1628345151259.png",
    "__typename": "StockTemplate"
}, {
    "id": 812,
    "name": "Hotel Advance Booking",
    "slug": "hotel-advance-booking",
    "rating": 4.68,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 18
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hotel-advance-booking/1627652119918.png",
    "__typename": "StockTemplate"
}, {
    "id": 810,
    "name": "IT Solutions & Services Company",
    "slug": "it-solutions-services-company",
    "rating": 4.9,
    "votes": {
        "4": 2,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/it-solutions-services-company/1628344997087.png",
    "__typename": "StockTemplate"
}, {
    "id": 808,
    "name": "Single Property & Apartment Booking",
    "slug": "single-property-apartment-booking",
    "rating": 4.63,
    "votes": {
        "3": 3,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/single-property-apartment-booking/1628344913318.png",
    "__typename": "StockTemplate"
}, {
    "id": 807,
    "name": "Travel & Tourism Advance Booking",
    "slug": "travel-and-tourism-advance-booking",
    "rating": 4.61,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/travel-and-tourism-advance-booking/1627651878236.png",
    "__typename": "StockTemplate"
}, {
    "id": 804,
    "name": "Meeting Follow Up",
    "slug": "meeting-follow-up",
    "rating": 4.7,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/meeting-follow-up/1627651497375.png",
    "__typename": "StockTemplate"
}, {
    "id": 800,
    "name": "Job Follow Up",
    "slug": "job-follow-up",
    "rating": 4.68,
    "votes": {
        "1": 2,
        "3": 1,
        "4": 2,
        "5": 32
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/job-follow-up/1628343704222.png",
    "__typename": "StockTemplate"
}, {
    "id": 797,
    "name": "Tech Support Follow Up",
    "slug": "tech-support-follow-up",
    "rating": 4.55,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/tech-support-follow-up/1628343460051.png",
    "__typename": "StockTemplate"
},{
    "id": 796,
    "name": "Trade Show Follow Up",
    "slug": "trade-show-follow-up",
    "rating": 4.43,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 5,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/trade-show-follow-up/1628204730352.png",
    "__typename": "StockTemplate"
}, {
    "id": 794,
    "name": "Home Decoration Service",
    "slug": "home-decoration-service",
    "rating": 4.38,
    "votes": {
        "1": 1,
        "2": 2,
        "3": 4,
        "4": 6,
        "5": 26
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/home-decoration-service/1628343333483.png",
    "__typename": "StockTemplate"
}, {
    "id": 793,
    "name": "Interview Follow Up",
    "slug": "interview-follow-up",
    "rating": 4.63,
    "votes": {
        "2": 1,
        "3": 2,
        "4": 6,
        "5": 26
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/interview-follow-up/1627472009846.png",
    "__typename": "StockTemplate"
}, {
    "id": 790,
    "name": "Hotel Booking Confirmation",
    "slug": "hotel-booking-confirmation",
    "rating": 4.72,
    "votes": {
        "2": 1,
        "3": 3,
        "4": 6,
        "5": 44
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hotel-booking-confirmation/1627650980638.png",
    "__typename": "StockTemplate"
}, {
    "id": 789,
    "name": "Music Playlist Promotion",
    "slug": "music-playlist-promotion",
    "rating": 4.62,
    "votes": {
        "4": 5,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-playlist-promotion/1650880396652.png",
    "__typename": "StockTemplate"
}, {
    "id": 750,
    "name": "Furniture Store Promotion",
    "slug": "furniture-store-promotion",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/furniture-store-promotion/1626170503605.png",
    "__typename": "StockTemplate"
}, {
    "id": 748,
    "name": "Business Conference Reminder",
    "slug": "business-conference-reminder",
    "rating": 4.81,
    "votes": {
        "2": 1,
        "4": 1,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/business-conference-reminder/1627649223427.png",
    "__typename": "StockTemplate"
}, {
    "id": 746,
    "name": "Music Band Event Promotion",
    "slug": "music-band-event-promotion",
    "rating": 5,
    "votes": {
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-band-event-promotion/1650880886121.png",
    "__typename": "StockTemplate"
}, {
    "id": 744,
    "name": "Non Profit Events Announcement",
    "slug": "non-profit-event-announcement",
    "rating": 4.91,
    "votes": {
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/non-profit-event-announcement/1628340791526.png",
    "__typename": "StockTemplate"
}, {
    "id": 742,
    "name": "Developer Resume",
    "slug": "developer-resume",
    "rating": 4.64,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/developer-resume/1628340623782.png",
    "__typename": "StockTemplate"
}, {
    "id": 738,
    "name": "Educational Institute",
    "slug": "educational-institute",
    "rating": 4.33,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 2,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/educational-institute/1628340526446.png",
    "__typename": "StockTemplate"
}, {
    "id": 737,
    "name": "Hotel Service Promotion",
    "slug": "hotel-service-promotion",
    "rating": 4.52,
    "votes": {
        "1": 1,
        "3": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hotel-service-promotion/1627641116114.png",
    "__typename": "StockTemplate"
}, {
    "id": 736,
    "name": "Hospital Medical Care ",
    "slug": "hospital-medical-care",
    "rating": 4.67,
    "votes": {
        "1": 2,
        "4": 1,
        "5": 24
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hospital-medical-care/1627640229206.png",
    "__typename": "StockTemplate"
}, {
    "id": 732,
    "name": "Book Your Course",
    "slug": "book-your-course",
    "rating": 4.6,
    "votes": {
        "3": 1,
        "4": 4,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/book-your-course/1628342462922.png",
    "__typename": "StockTemplate"
}, {
    "id": 726,
    "name": "Natural Products Promotion",
    "slug": "natural-products-promotion",
    "rating": 3.43,
    "votes": {
        "3": 16,
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/natural-products-promotion/1625734477417.png",
    "__typename": "StockTemplate"
}, {
    "id": 725,
    "name": "Tech Shop Customer Service",
    "slug": "tech-shop-customer-service",
    "rating": 4,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/tech-shop-customer-service/1627471438722.png",
    "__typename": "StockTemplate"
}, {
    "id": 723,
    "name": "Housekeeping Customer Service",
    "slug": "housekeeping-customer-service",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/housekeeping-customer-service/1627639785325.png",
    "__typename": "StockTemplate"
}, {
    "id": 719,
    "name": "Car Wash Customer Service ",
    "slug": "car-wash-customer-service",
    "rating": 5,
    "votes": {
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/car-wash-customer-service/1628340399388.png",
    "__typename": "StockTemplate"
}, {
    "id": 718,
    "name": "Real Estate Properties",
    "slug": "real-estate-properties",
    "rating": 4.65,
    "votes": {
        "1": 1,
        "4": 9,
        "5": 27
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/real-estate-properties/1624879490457.png",
    "__typename": "StockTemplate"
}, {
    "id": 715,
    "name": "Salon Customer Service",
    "slug": "salon-customer-service",
    "rating": 4.8,
    "votes": {
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/salon-customer-service/1627471419691.png",
    "__typename": "StockTemplate"
}, {
    "id": 714,
    "name": "Sports Tournament",
    "slug": "sports-tournament",
    "rating": 4.92,
    "votes": {
        "4": 1,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sports-tournament/1624358971171.png",
    "__typename": "StockTemplate"
}, {
    "id": 713,
    "name": "Music Concert Event",
    "slug": "music-concert-event",
    "rating": 4.89,
    "votes": {
        "4": 3,
        "5": 24
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-concert-event/1624358872024.png",
    "__typename": "StockTemplate"
}, {
    "id": 712,
    "name": "Sports Equipment Shop",
    "slug": "sports-equipment-shop",
    "rating": 4.94,
    "votes": {
        "3": 1,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sports-equipment-shop/1624358743678.png",
    "__typename": "StockTemplate"
}, {
    "id": 710,
    "name": "Insurance Promotion",
    "slug": "Insurance-promotion",
    "rating": 4.87,
    "votes": {
        "4": 2,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/Insurance-promotion/1627470618500.png",
    "__typename": "StockTemplate"
}, {
    "id": 709,
    "name": "Golf Tournament",
    "slug": "golf-tournament",
    "rating": 4.88,
    "votes": {
        "4": 1,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/golf-tournament/1625573403964.png",
    "__typename": "StockTemplate"
}, {
    "id": 707,
    "name": "Hotel Customer Service",
    "slug": "hotel-customer-service",
    "rating": 4.48,
    "votes": {
        "2": 2,
        "3": 2,
        "4": 6,
        "5": 21
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hotel-customer-service/1627471445968.png",
    "__typename": "StockTemplate"
}, {
    "id": 706,
    "name": "Travel World",
    "slug": "travel-world",
    "rating": 4.94,
    "votes": {
        "4": 1,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/travel-world/1625572156215.png",
    "__typename": "StockTemplate"
}, {
    "id": 704,
    "name": "Restaurant Customer Service",
    "slug": "restaurant-customer-service",
    "rating": 4.9,
    "votes": {
        "4": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/restaurant-customer-service/1627472071366.png",
    "__typename": "StockTemplate"
}, {
    "id": 703,
    "name": "Retirement Senior Care",
    "slug": "retirement-senior-care",
    "rating": 4.85,
    "votes": {
        "4": 2,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/retirement-senior-care/1624262348485.png",
    "__typename": "StockTemplate"
}, {
    "id": 702,
    "name": "Beauty Cosmetics Shop",
    "slug": "beauty-cosmetics-shop",
    "rating": 4.79,
    "votes": {
        "4": 3,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/beauty-cosmetics-shop/1624358293581.png",
    "__typename": "StockTemplate"
}, {
    "id": 696,
    "name": "Employee Engagement Survey",
    "slug": "employee-engagement-survey",
    "rating": 4.69,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 4,
        "5": 30
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/employee-engagement-survey/1623750915511.png",
    "__typename": "StockTemplate"
}, {
    "id": 693,
    "name": "Father's Day Business Development Event",
    "slug": "fathers-day-business-development-event",
    "rating": 4.8,
    "votes": {
        "4": 12,
        "5": 47
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fathers-day-business-development-event/1623672705083.png",
    "__typename": "StockTemplate"
}, {
    "id": 690,
    "name": "Father's Day Fashion Accessories ",
    "slug": "fathers-day-fashion-accessories",
    "rating": 4.8,
    "votes": {
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fathers-day-fashion-accessories/1623751980995.png",
    "__typename": "StockTemplate"
}, {
    "id": 683,
    "name": "Compliance Training Reminder",
    "slug": "compliance-training-reminder",
    "rating": 4.31,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 6,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/compliance-training-reminder/1623673736642.png",
    "__typename": "StockTemplate"
}, {
    "id": 682,
    "name": "Meeting Reminder",
    "slug": "meeting-reminder",
    "rating": 4.22,
    "votes": {
        "1": 2,
        "3": 3,
        "4": 7,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/meeting-reminder/1623673948436.png",
    "__typename": "StockTemplate"
}, {
    "id": 679,
    "name": "Interior Design Service",
    "slug": "interior-design-service",
    "rating": 4.75,
    "votes": {
        "4": 3,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/interior-design-service/1649673468939.png",
    "__typename": "StockTemplate"
}, {
    "id": 678,
    "name": "Appointment Reminder",
    "slug": "appointment-reminder",
    "rating": 4.67,
    "votes": {
        "1": 3,
        "2": 2,
        "3": 6,
        "4": 32,
        "5": 144
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/appointment-reminder/1623674754420.png",
    "__typename": "StockTemplate"
}, {
    "id": 677,
    "name": "Culinary Weekend Event Reminder",
    "slug": "culinary-weekend-event-reminder",
    "rating": 5,
    "votes": {
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/culinary-weekend-event-reminder/1623674933469.png",
    "__typename": "StockTemplate"
}, {
    "id": 676,
    "name": "Legal Consultancy Service",
    "slug": "legal-consultancy-service",
    "rating": 4.82,
    "votes": {
        "4": 2,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/legal-consultancy-service/1623753606828.png",
    "__typename": "StockTemplate"
}, {
    "id": 675,
    "name": "Invoice Payment Reminder ",
    "slug": "invoice-payment-reminder",
    "rating": 4.67,
    "votes": {
        "3": 7,
        "4": 16,
        "5": 68
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/invoice-payment-reminder/1650873789345.png",
    "__typename": "StockTemplate"
}, {
    "id": 667,
    "name": "Furniture Promotion",
    "slug": "furniture-promotion",
    "rating": 4,
    "votes": {
        "3": 2,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/furniture-promotion/1627471734583.png",
    "__typename": "StockTemplate"
}, {
    "id": 662,
    "name": "Welcome Email for Watch Store",
    "slug": "welcome-email-for-watch-store",
    "rating": 4.76,
    "votes": {
        "3": 1,
        "4": 5,
        "5": 23
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/welcome-email-for-watch-store/1623103978054.png",
    "__typename": "StockTemplate"
}, {
    "id": 661,
    "name": "New Client Onboarding",
    "slug": "new-client-onboarding",
    "rating": 4.64,
    "votes": {
        "2": 1,
        "4": 2,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-client-onboarding/1623054831153.png",
    "__typename": "StockTemplate"
}, {
    "id": 645,
    "name": "Birthday Photography",
    "slug": "birthday-photography",
    "rating": 4.94,
    "votes": {
        "4": 1,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/birthday-photography/1658391128751.png",
    "__typename": "StockTemplate"
}, {
    "id": 644,
    "name": "Photographer Contract Signing",
    "slug": "photographer-contract-signing",
    "rating": 4.57,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/photographer-contract-signing/1622545334141.png",
    "__typename": "StockTemplate"
}, {
    "id": 643,
    "name": "Creative Portrait Photography",
    "slug": "creative-portrait-photography",
    "rating": 5,
    "votes": {
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/creative-portrait-photography/1622545993065.png",
    "__typename": "StockTemplate"
}, {
    "id": 641,
    "name": "Food Photography",
    "slug": "food-photography",
    "rating": 5,
    "votes": {
        "5": 23
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/food-photography/1622546648962.png",
    "__typename": "StockTemplate"
}, {
    "id": 632,
    "name": "Online Courses Company",
    "slug": "online-courses-company",
    "rating": 4.86,
    "votes": {
        "4": 6,
        "5": 36
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-courses-company/1622550280688.png",
    "__typename": "StockTemplate"
}, {
    "id": 631,
    "name": "Graduation Ceremony Announcement",
    "slug": "graduation-ceremony-announcement",
    "rating": 4.65,
    "votes": {
        "3": 1,
        "4": 4,
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/graduation-ceremony-announcement/1623104375725.png",
    "__typename": "StockTemplate"
}, {
    "id": 629,
    "name": "Luxury Apartments ",
    "slug": "luxury-apartments",
    "rating": 4.29,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 1,
        "4": 7,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/luxury-apartments/1622551443039.png",
    "__typename": "StockTemplate"
}, {
    "id": 624,
    "name": "New Software Release",
    "slug": "new-software-release",
    "rating": 4.69,
    "votes": {
        "3": 3,
        "4": 14,
        "5": 47
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-software-release/1622630006705.png",
    "__typename": "StockTemplate"
}, {
    "id": 615,
    "name": "Prize Winner Announcement",
    "slug": "prize-winner-announcement",
    "rating": 4.74,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 7,
        "4": 17,
        "5": 119
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/prize-winner-announcement/1623104424988.png",
    "__typename": "StockTemplate"
}, {
    "id": 598,
    "name": "4th of July Flash Sales",
    "slug": "4th-of-july-flash-sales",
    "rating": 4.31,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 3,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/4th-of-july-flash-sales/1622715039268.png",
    "__typename": "StockTemplate"
}, {
    "id": 596,
    "name": "4th of July Promotion",
    "slug": "4th-of-july-promotion",
    "rating": 4.38,
    "votes": {
        "2": 1,
        "4": 2,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/4th-of-july-promotion/1627471772261.png",
    "__typename": "StockTemplate"
}, {
    "id": 587,
    "name": "Digital Conference",
    "slug": "digital-conference",
    "rating": 4.1,
    "votes": {
        "4": 9,
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/digital-conference/1621235688284.png",
    "__typename": "StockTemplate"
}, {
    "id": 581,
    "name": "Creative Web Agency",
    "slug": "creative-web-agency",
    "rating": 4.79,
    "votes": {
        "3": 1,
        "4": 9,
        "5": 43
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/creative-web-agency/1623144175970.png",
    "__typename": "StockTemplate"
}, {
    "id": 577,
    "name": "A Night To Remember",
    "slug": "a-night-to-remember",
    "rating": 4.09,
    "votes": {
        "1": 3,
        "2": 2,
        "4": 2,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/a-night-to-remember/1623144331602.png",
    "__typename": "StockTemplate"
}, {
    "id": 576,
    "name": "Elevator Pitch",
    "slug": "elevator-pitch",
    "rating": 4.33,
    "votes": {
        "3": 1,
        "4": 22,
        "5": 13
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/elevator-pitch/1623144497059.png",
    "__typename": "StockTemplate"
}, {
    "id": 575,
    "name": "Generic Sales Follow Up",
    "slug": "generic-sales-follow-up",
    "rating": 4.13,
    "votes": {
        "3": 3,
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/generic-sales-follow-up/1627470896693.png",
    "__typename": "StockTemplate"
}, {
    "id": 570,
    "name": "Mobile App Promotion",
    "slug": "mobile-app-promotion",
    "rating": 4.86,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 20
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mobile-app-promotion/1620302069467.png",
    "__typename": "StockTemplate"
}, {
    "id": 566,
    "name": "Thanks Subscriber",
    "slug": "thanks-subscriber",
    "rating": 4.54,
    "votes": {
        "1": 2,
        "3": 3,
        "4": 2,
        "5": 28
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/thanks-subscriber/1623104765599.png",
    "__typename": "StockTemplate"
}, {
    "id": 563,
    "name": "Event Confirmation",
    "slug": "event-confirmation",
    "rating": 4.73,
    "votes": {
        "1": 4,
        "2": 1,
        "3": 3,
        "4": 25,
        "5": 153
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/event-confirmation/1620389410074.png",
    "__typename": "StockTemplate"
}, {
    "id": 562,
    "name": "Delivery Confirmed",
    "slug": "delivery-confirmed",
    "rating": 4.44,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/delivery-confirmed/1620389431644.png",
    "__typename": "StockTemplate"
}, {
    "id": 558,
    "name": "Registration Confirmation",
    "slug": "registration-confirmation",
    "rating": 4.81,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 6,
        "5": 49
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/registration-confirmation/1620174337959.png",
    "__typename": "StockTemplate"
}, {
    "id": 556,
    "name": "Shipping Confirmation",
    "slug": "shipping-confirmation",
    "rating": 4.81,
    "votes": {
        "1": 1,
        "3": 3,
        "4": 11,
        "5": 95
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/shipping-confirmation/1620049512029.png",
    "__typename": "StockTemplate"
}, {
    "id": 552,
    "name": "Payment Reminder",
    "slug": "payment-reminder",
    "rating": 4.86,
    "votes": {
        "4": 5,
        "5": 31
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/payment-reminder/1623104650000.png",
    "__typename": "StockTemplate"
}, {
    "id": 551,
    "name": "Past Due Invoice",
    "slug": "past-due-invoice",
    "rating": 4.68,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 3,
        "5": 28
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/past-due-invoice/1650874185850.png",
    "__typename": "StockTemplate"
}, {
    "id": 550,
    "name": "Medical Promotion",
    "slug": "medical-promotion",
    "rating": 4.83,
    "votes": {
        "3": 1,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/medical-promotion/1656761336662.png",
    "__typename": "StockTemplate"
}, {
    "id": 547,
    "name": "Green Planet",
    "slug": "green-planet",
    "rating": 4.9,
    "votes": {
        "4": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/green-planet/1619769773492.png",
    "__typename": "StockTemplate"
}, {
    "id": 546,
    "name": "Trending Products",
    "slug": "trending-products",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/trending-products/1619703299884.png",
    "__typename": "StockTemplate"
}, {
    "id": 544,
    "name": "Marketing Agency",
    "slug": "marketing-agency",
    "rating": 4.49,
    "votes": {
        "1": 6,
        "2": 3,
        "3": 1,
        "4": 20,
        "5": 78
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/marketing-agency/1619702539502.png",
    "__typename": "StockTemplate"
}, {
    "id": 542,
    "name": "Personal Trainer",
    "slug": "personal-trainer",
    "rating": 4.78,
    "votes": {
        "3": 1,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/personal-trainer/1619701924356.png",
    "__typename": "StockTemplate"
}, {
    "id": 541,
    "name": "Course Collection",
    "slug": "course-collection",
    "rating": 4.86,
    "votes": {
        "4": 3,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/course-collection/1619701560600.png",
    "__typename": "StockTemplate"
}, {
    "id": 540,
    "name": "Car Dealership",
    "slug": "car-dealership",
    "rating": 4.88,
    "votes": {
        "4": 3,
        "5": 22
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/car-dealership/1619701205876.png",
    "__typename": "StockTemplate"
}, {
    "id": 539,
    "name": "Giving Tuesday",
    "slug": "giving-tuesday",
    "rating": 4.36,
    "votes": {
        "3": 6,
        "4": 6,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/giving-tuesday/1619772807444.png",
    "__typename": "StockTemplate"
}, {
    "id": 535,
    "name": "Hackathon",
    "slug": "hackathon",
    "rating": 4.59,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 3,
        "5": 17
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/hackathon/1619621479602.png",
    "__typename": "StockTemplate"
}, {
    "id": 532,
    "name": "Body Care Bestsellers",
    "slug": "body-care-bestsellers",
    "rating": 3,
    "votes": {
        "3": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/body-care-bestsellers/1619620575888.png",
    "__typename": "StockTemplate"
}, {
    "id": 531,
    "name": "Payment Confirmation",
    "slug": "payment-confirmation",
    "rating": 4.77,
    "votes": {
        "1": 1,
        "4": 6,
        "5": 36
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/payment-confirmation/1619620210242.png",
    "__typename": "StockTemplate"
}, {
    "id": 528,
    "name": "May Day Sale",
    "slug": "may-day-sale",
    "rating": 5,
    "votes": {
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/may-day-sale/1619618176226.png",
    "__typename": "StockTemplate"
}, {
    "id": 524,
    "name": "Peer to Peer Fundraising",
    "slug": "peer-to-peer-fundraising",
    "rating": 4.93,
    "votes": {
        "4": 1,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/peer-to-peer-fundraising/1619527065516.png",
    "__typename": "StockTemplate"
}, {
    "id": 522,
    "name": "Webinar Follow Up",
    "slug": "webinar-follow-up",
    "rating": 4.58,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/webinar-follow-up/1627470838358.png",
    "__typename": "StockTemplate"
}, {
    "id": 520,
    "name": "Post Webinar",
    "slug": "post-webinar",
    "rating": 4.89,
    "votes": {
        "4": 3,
        "5": 24
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/post-webinar/1620647462716.png",
    "__typename": "StockTemplate"
}, {
    "id": 517,
    "name": "Test Drive",
    "slug": "test-drive",
    "rating": 3.88,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 1,
        "5": 4
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/test-drive/1619265824668.png",
    "__typename": "StockTemplate"
}, {
    "id": 516,
    "name": "Car Dealer",
    "slug": "car-dealer",
    "rating": 4.27,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 2,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/car-dealer/1619265923240.png",
    "__typename": "StockTemplate"
}, {
    "id": 515,
    "name": "Product Photography",
    "slug": "product-photography",
    "rating": 4.83,
    "votes": {
        "4": 1,
        "5": 5
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/product-photography/1619056362334.png",
    "__typename": "StockTemplate"
}, {
    "id": 481,
    "name": "Portrait Photography",
    "slug": "portrait-photography",
    "rating": 5,
    "votes": {
        "5": 12
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/portrait-photography/1618833984623.png",
    "__typename": "StockTemplate"
}, {
    "id": 479,
    "name": "World Water Day",
    "slug": "world-water-day",
    "rating": 4.3,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/world-water-day/1618545575384.png",
    "__typename": "StockTemplate"
}, {
    "id": 467,
    "name": "Best Coffee",
    "slug": "best-coffee",
    "rating": 4.5,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/best-coffee/1618544393699.png",
    "__typename": "StockTemplate"
}, {
    "id": 465,
    "name": "Account Created",
    "slug": "account-created",
    "rating": 4.76,
    "votes": {
        "3": 5,
        "4": 7,
        "5": 59
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/account-created/1618545679175.png",
    "__typename": "StockTemplate"
}, {
    "id": 463,
    "name": "Game",
    "slug": "game",
    "rating": 4.88,
    "votes": {
        "4": 3,
        "5": 21
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/game/1618545711161.png",
    "__typename": "StockTemplate"
}, {
    "id": 462,
    "name": "Remote Working",
    "slug": "special-offers",
    "rating": 4.75,
    "votes": {
        "3": 1,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/special-offers/1617631379908.png",
    "__typename": "StockTemplate"
}, {
    "id": 460,
    "name": "Food Offer",
    "slug": "offers",
    "rating": 4.73,
    "votes": {
        "4": 6,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/offers/1618545772898.png",
    "__typename": "StockTemplate"
}, {
    "id": 457,
    "name": "Cinco de Mayo",
    "slug": "cinco-de-mayo",
    "rating": 4.43,
    "votes": {
        "1": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cinco-de-mayo/1618545799740.png",
    "__typename": "StockTemplate"
}, {
    "id": 455,
    "name": "Graduation Ceremony",
    "slug": "graduation-ceremony",
    "rating": 3,
    "votes": {
        "1": 2,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/graduation-ceremony/1618132311601.png",
    "__typename": "StockTemplate"
}, {
    "id": 454,
    "name": " Reset Password",
    "slug": "reset-password",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/reset-password/1618545858428.png",
    "__typename": "StockTemplate"
}, {
    "id": 415,
    "name": "Labor Day ",
    "slug": "labor-day",
    "rating": 5,
    "votes": {
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/labor-day/1629235354949.png",
    "__typename": "StockTemplate"
}, {
    "id": 409,
    "name": "Body Fitness ",
    "slug": "body-fitness",
    "rating": 4.7,
    "votes": {
        "4": 3,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/body-fitness/1618545049091.png",
    "__typename": "StockTemplate"
}, {
    "id": 408,
    "name": "Massage Spa",
    "slug": "massage-spa",
    "rating": 4.76,
    "votes": {
        "1": 1,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/massage-spa/1618545155579.png",
    "__typename": "StockTemplate"
}, {
    "id": 407,
    "name": "Sports Equipment",
    "slug": "sports-equipment",
    "rating": 4.8,
    "votes": {
        "4": 2,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sports-equipment/1618545167931.png",
    "__typename": "StockTemplate"
}, {
    "id": 406,
    "name": "Welcome Email",
    "slug": "welcome-email",
    "rating": 4.62,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 5,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/welcome-email/1623103835169.png",
    "__typename": "StockTemplate"
},{
    "id": 405,
    "name": "Technology",
    "slug": "technology",
    "rating": 4.3,
    "votes": {
        "1": 3,
        "2": 3,
        "3": 4,
        "4": 6,
        "5": 34
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/technology/1618545239914.png",
    "__typename": "StockTemplate"
}, {
    "id": 400,
    "name": "Video promotion",
    "slug": "video-promotion",
    "rating": 4.76,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 14
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/video-promotion/1615832048163.png",
    "__typename": "StockTemplate"
}, {
    "id": 397,
    "name": "Fast Food",
    "slug": "fast-food",
    "rating": 3.56,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 2,
        "4": 2,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fast-food/1616730662939.png",
    "__typename": "StockTemplate"
}, {
    "id": 396,
    "name": "Organic Product",
    "slug": "organic-product",
    "rating": 4.9,
    "votes": {
        "4": 1,
        "5": 9
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/organic-product/1615371390615.png",
    "__typename": "StockTemplate"
}, {
    "id": 394,
    "name": "Account Completion",
    "slug": "registration-completion",
    "rating": 4.74,
    "votes": {
        "1": 2,
        "3": 1,
        "4": 11,
        "5": 68
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/registration-completion/1617617735997.png",
    "__typename": "StockTemplate"
}, {
    "id": 393,
    "name": "Nail Care",
    "slug": "cosmetic-product",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cosmetic-product/1614415872013.png",
    "__typename": "StockTemplate"
}, {
    "id": 390,
    "name": "Sports Channel",
    "slug": "sports-channel",
    "rating": 4.5,
    "votes": {
        "4": 1,
        "5": 1
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sports-channel/1614363363794.png",
    "__typename": "StockTemplate"
}, {
    "id": 389,
    "name": "Content Creator",
    "slug": "content-creator",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/content-creator/1614352554056.png",
    "__typename": "StockTemplate"
}, {
    "id": 387,
    "name": "Annual Review",
    "slug": "review-template",
    "rating": 4.89,
    "votes": {
        "4": 1,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/review-template/1614339361318.png",
    "__typename": "StockTemplate"
}, {
    "id": 386,
    "name": "Online Store",
    "slug": "online-store",
    "rating": 4.56,
    "votes": {
        "1": 2,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-store/1617457227641.png",
    "__typename": "StockTemplate"
}, {
    "id": 385,
    "name": "Seasonal Recipes",
    "slug": "seasonal-recipes",
    "rating": 4.85,
    "votes": {
        "4": 4,
        "5": 22
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/seasonal-recipes/1616730676956.png",
    "__typename": "StockTemplate"
}, {
    "id": 383,
    "name": "Best Collection",
    "slug": "new-products",
    "rating": 4.1,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 2,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-products/1617457636394.png",
    "__typename": "StockTemplate"
}, {
    "id": 378,
    "name": "Business Advertising",
    "slug": "business-advertising",
    "rating": 4.94,
    "votes": {
        "4": 1,
        "5": 15
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/business-advertising/1618484596509.png",
    "__typename": "StockTemplate"
}, {
    "id": 374,
    "name": "Birthday Discount ",
    "slug": "birthday-special-discount",
    "rating": 4.76,
    "votes": {
        "1": 1,
        "5": 16
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/birthday-special-discount/1613465422990.png",
    "__typename": "StockTemplate"
}, {
    "id": 373,
    "name": "Makeup Idea",
    "slug": "blog",
    "rating": 4.5,
    "votes": {
        "4": 2,
        "5": 2
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/blog/1613459747426.png",
    "__typename": "StockTemplate"
}, {
    "id": 371,
    "name": "Global Generosity",
    "slug": "global-generosity",
    "rating": 4.78,
    "votes": {
        "4": 2,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/global-generosity/1613325128830.png",
    "__typename": "StockTemplate"
}, {
    "id": 370,
    "name": "Vacation",
    "slug": "vacation",
    "rating": 4.83,
    "votes": {
        "3": 1,
        "5": 11
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/vacation/1617503948768.png",
    "__typename": "StockTemplate"
}, {
    "id": 369,
    "name": "New Blog Post",
    "slug": "new-blog-post",
    "rating": 4.6,
    "votes": {
        "4": 2,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-blog-post/1617454888686.png",
    "__typename": "StockTemplate"
}, {
    "id": 335,
    "name": "Furnished Furniture",
    "slug": "furnished-furniture",
    "rating": 4.83,
    "votes": {
        "4": 2,
        "5": 10
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/furnished-furniture/1617455419099.png",
    "__typename": "StockTemplate"
}, {
    "id": 332,
    "name": "Fashion Week",
    "slug": "fashion-week",
    "rating": 4.71,
    "votes": {
        "3": 1,
        "5": 6
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fashion-week/1654417822225.png",
    "__typename": "StockTemplate"
}, {
    "id": 331,
    "name": "Agency Services",
    "slug": "agency-services",
    "rating": 4.36,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 2,
        "5": 7
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/agency-services/1617457799008.png",
    "__typename": "StockTemplate"
}, {
    "id": 329,
    "name": "Food Blogger",
    "slug": "food-blogger",
    "rating": 4.8,
    "votes": {
        "3": 3,
        "4": 1,
        "5": 31
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/food-blogger/1612682548752.png",
    "__typename": "StockTemplate"
}, {
    "id": 328,
    "name": "Week’s trending",
    "slug": "weeks-trending",
    "rating": 4.75,
    "votes": {
        "4": 1,
        "5": 3
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/weeks-trending/1612682941758.png",
    "__typename": "StockTemplate"
}, {
    "id": 325,
    "name": "Technology Devices",
    "slug": "notification",
    "rating": 4.46,
    "votes": {
        "1": 1,
        "2": 2,
        "4": 4,
        "5": 19
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/notification/1617617849076.png",
    "__typename": "StockTemplate"
}, {
    "id": 323,
    "name": "Valentine Day Sale",
    "slug": "valentine-day-sale",
    "rating": 3.61,
    "votes": {
        "1": 3,
        "2": 1,
        "3": 4,
        "4": 2,
        "5": 8
    },
    "position": null,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/valentine-day-sale/1620647179636.png",
    "__typename": "StockTemplate"
}, {
    "id": 317,
    "name": "Gadget",
    "slug": "mobile-phone",
    "rating": 4.42,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 1,
        "5": 9
    },
    "position": 174,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mobile-phone/1612096586572.png",
    "__typename": "StockTemplate"
}, {
    "id": 314,
    "name": "Trial Ended",
    "slug": "trial-ended",
    "rating": 4.67,
    "votes": {
        "4": 2,
        "5": 4
    },
    "position": 179,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/trial-ended/1617617798997.png",
    "__typename": "StockTemplate"
}, {
    "id": 312,
    "name": "Gymnasium",
    "slug": "fitness-email",
    "rating": 4.86,
    "votes": {
        "4": 2,
        "5": 12
    },
    "position": 180,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fitness-email/1611779537597.png",
    "__typename": "StockTemplate"
}, {
    "id": 309,
    "name": "Weather Application",
    "slug": "weather-application",
    "rating": 4,
    "votes": {
        "1": 1,
        "3": 2,
        "5": 5
    },
    "position": 183,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/weather-application/1617617771097.png",
    "__typename": "StockTemplate"
}, {
    "id": 308,
    "name": "New Product",
    "slug": "new-product",
    "rating": 4.3,
    "votes": {
        "2": 1,
        "3": 4,
        "4": 5,
        "5": 13
    },
    "position": 175,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-product/1617457999761.png",
    "__typename": "StockTemplate"
}, {
    "id": 304,
    "name": "Watch",
    "slug": "watch",
    "rating": 4.5,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 6
    },
    "position": 170,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/watch/1611121343143.png",
    "__typename": "StockTemplate"
}, {
    "id": 303,
    "name": "Game Activation",
    "slug": "game-activation",
    "rating": 4.72,
    "votes": {
        "1": 2,
        "4": 4,
        "5": 37
    },
    "position": 178,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/game-activation/1618402592546.png",
    "__typename": "StockTemplate"
}, {
    "id": 302,
    "name": "Exercise",
    "slug": "exercise",
    "rating": 4.86,
    "votes": {
        "4": 1,
        "5": 6
    },
    "position": 177,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/exercise/1610802675873.png",
    "__typename": "StockTemplate"
}, {
    "id": 294,
    "name": "Restaurant Delivery",
    "slug": "holiday-sale",
    "rating": 4.81,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 18
    },
    "position": 166,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/holiday-sale/1610553856159.png",
    "__typename": "StockTemplate"
}, {
    "id": 293,
    "name": "Valentine's Day Promotion",
    "slug": "valentines-day-promotion",
    "rating": 4.73,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 9
    },
    "position": 163,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/valentines-day-promotion/1620647167116.png",
    "__typename": "StockTemplate"
}, {
    "id": 292,
    "name": "Royal Apartments",
    "slug": "realestate",
    "rating": 4.44,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 7
    },
    "position": 164,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/realestate/1610386634832.png",
    "__typename": "StockTemplate"
}, {
    "id": 286,
    "name": "Dress Shop",
    "slug": "dress",
    "rating": 4.69,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 10
    },
    "position": 165,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/dress/1610386512349.png",
    "__typename": "StockTemplate"
}, {
    "id": 285,
    "name": "Online Shop",
    "slug": "online-shop",
    "rating": 4.81,
    "votes": {
        "4": 4,
        "5": 17
    },
    "position": 167,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-shop/1610553753806.png",
    "__typename": "StockTemplate"
}, {
    "id": 284,
    "name": "Christmas Discount",
    "slug": "christmas-discount",
    "rating": 4.7,
    "votes": {
        "1": 1,
        "2": 3,
        "3": 2,
        "4": 13,
        "5": 81
    },
    "position": 161,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/christmas-discount/1620646893561.png",
    "__typename": "StockTemplate"
}, {
    "id": 283,
    "name": "Fitness",
    "slug": "fitness-communication",
    "rating": 4.56,
    "votes": {
        "1": 20,
        "2": 7,
        "3": 19,
        "4": 66,
        "5": 353
    },
    "position": 1,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/fitness-communication/1636589569385.png",
    "__typename": "StockTemplate"
}, {
    "id": 282,
    "name": "Product Advertisement",
    "slug": "product-advertisement",
    "rating": 4.49,
    "votes": {
        "1": 4,
        "2": 2,
        "3": 4,
        "4": 13,
        "5": 62
    },
    "position": 0,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/product-advertisement/1617454978550.png",
    "__typename": "StockTemplate"
}, {
    "id": 281,
    "name": "Happy Valentines",
    "slug": "happy-valentine",
    "rating": 4.52,
    "votes": {
        "1": 3,
        "2": 2,
        "3": 3,
        "4": 9,
        "5": 52
    },
    "position": 9,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/happy-valentine/1629231574867.png",
    "__typename": "StockTemplate"
}, {
    "id": 278,
    "name": "Tourism",
    "slug": "tourism",
    "rating": 4.5,
    "votes": {
        "1": 1,
        "4": 1,
        "5": 8
    },
    "position": 160,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/tourism/1609863151991.png",
    "__typename": "StockTemplate"
}, {
    "id": 277,
    "name": "Online Events",
    "slug": "online-events",
    "rating": 4.87,
    "votes": {
        "4": 2,
        "5": 13
    },
    "position": 159,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-events/1609863192714.png",
    "__typename": "StockTemplate"
}, {
    "id": 273,
    "name": "Black Friday Offer",
    "slug": "black-friday-offer",
    "rating": 4.61,
    "votes": {
        "2": 1,
        "4": 11,
        "5": 24
    },
    "position": 92,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-friday-offer/1620646580405.png",
    "__typename": "StockTemplate"
}, {
    "id": 267,
    "name": "Adventure Tour",
    "slug": "adventure-tour",
    "rating": 4.7,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 8
    },
    "position": 147,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/adventure-tour/1603356209439.png",
    "__typename": "StockTemplate"
}, {
    "id": 264,
    "name": "IT Company",
    "slug": "it-company",
    "rating": 4.5,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 6,
        "5": 21
    },
    "position": 143,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/it-company/1617456474756.png",
    "__typename": "StockTemplate"
}, {
    "id": 263,
    "name": "Free Shipping Offer",
    "slug": "free-shipping-offer",
    "rating": 5,
    "votes": {
        "5": 17
    },
    "position": 104,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/free-shipping-offer/1603032062849.png",
    "__typename": "StockTemplate"
}, {
    "id": 262,
    "name": "Travel Packages",
    "slug": "travel-packages",
    "rating": 5,
    "votes": {
        "5": 15
    },
    "position": 144,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/travel-packages/1602831975066.png",
    "__typename": "StockTemplate"
}, {
    "id": 261,
    "name": "Moving company",
    "slug": "moving-company",
    "rating": 4.56,
    "votes": {
        "3": 1,
        "4": 6,
        "5": 11
    },
    "position": 133,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/moving-company/1603032259430.png",
    "__typename": "StockTemplate"
}, {
    "id": 257,
    "name": "Quiz Time",
    "slug": "quiz-time",
    "rating": 4.96,
    "votes": {
        "4": 1,
        "5": 25
    },
    "position": 113,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/quiz-time/1617455101041.png",
    "__typename": "StockTemplate"
}, {
    "id": 252,
    "name": "Latest News",
    "slug": "latest-news",
    "rating": 4.17,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 8
    },
    "position": 109,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/latest-news/1617457533242.png",
    "__typename": "StockTemplate"
}, {
    "id": 254,
    "name": "Corporate Services",
    "slug": "corporate-services",
    "rating": 4.64,
    "votes": {
        "3": 2,
        "4": 5,
        "5": 18
    },
    "position": 106,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/corporate-services/1618402013632.png",
    "__typename": "StockTemplate"
}, {
    "id": 251,
    "name": "Concert Event",
    "slug": "concert-event",
    "rating": 4.85,
    "votes": {
        "4": 2,
        "5": 11
    },
    "position": 108,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/concert-event/1602166991895.png",
    "__typename": "StockTemplate"
}, {
    "id": 239,
    "name": "Mid Season Sale",
    "slug": "mid-season-sale",
    "rating": 4.64,
    "votes": {
        "2": 1,
        "4": 1,
        "5": 9
    },
    "position": 101,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mid-season-sale/1602167095753.png",
    "__typename": "StockTemplate"
}, {
    "id": 238,
    "name": "Sales Boot Camp",
    "slug": "sales-boot-camp",
    "rating": 4.86,
    "votes": {
        "4": 8,
        "5": 48
    },
    "position": 60,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sales-boot-camp/1602167077472.png",
    "__typename": "StockTemplate"
}, {
    "id": 248,
    "name": "Invoice",
    "slug": "invoice",
    "rating": 4.74,
    "votes": {
        "3": 4,
        "4": 16,
        "5": 71
    },
    "position": 96,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/invoice/1650873728519.png",
    "__typename": "StockTemplate"
}, {
    "id": 246,
    "name": "Promotional Newsletter",
    "slug": "promotional-newsletter",
    "rating": 4.48,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 7,
        "5": 16
    },
    "position": 97,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/promotional-newsletter/1627471685726.png",
    "__typename": "StockTemplate"
}, {
    "id": 249,
    "name": "Webinar Invite",
    "slug": "webinar-invite",
    "rating": 4.48,
    "votes": {
        "1": 2,
        "3": 3,
        "4": 25,
        "5": 45
    },
    "position": 94,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/webinar-invite/1620647443389.png",
    "__typename": "StockTemplate"
}, {
    "id": 247,
    "name": "Summer Wardrobe",
    "slug": "summer-wardrobe",
    "rating": 4.67,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 9
    },
    "position": 98,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/summer-wardrobe/1616732785981.png",
    "__typename": "StockTemplate"
}, {
    "id": 242,
    "name": "Barber Shops",
    "slug": "barber-shops",
    "rating": 4.63,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 6
    },
    "position": 81,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/barber-shops/1617458427972.png",
    "__typename": "StockTemplate"
}, {
    "id": 241,
    "name": "Top Stories",
    "slug": "top-stories",
    "rating": 4.89,
    "votes": {
        "4": 4,
        "5": 34
    },
    "position": 99,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/top-stories/1617457424947.png",
    "__typename": "StockTemplate"
}, {
    "id": 240,
    "name": "Launch New App",
    "slug": "launch-new-app",
    "rating": 4.55,
    "votes": {
        "3": 1,
        "4": 7,
        "5": 12
    },
    "position": 95,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/launch-new-app/1617617881003.png",
    "__typename": "StockTemplate"
}, {
    "id": 243,
    "name": "Real Estate News",
    "slug": "real-estate-news",
    "rating": 4.8,
    "votes": {
        "4": 4,
        "5": 16
    },
    "position": 91,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/real-estate-news/1602166568262.png",
    "__typename": "StockTemplate"
}, {
    "id": 245,
    "name": "Happy Birthday",
    "slug": "happy-birthday",
    "rating": 4.53,
    "votes": {
        "1": 5,
        "2": 1,
        "3": 3,
        "4": 11,
        "5": 65
    },
    "position": 100,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/happy-birthday/1658389363824.png",
    "__typename": "StockTemplate"
}, {
    "id": 244,
    "name": "Black Friday Deal",
    "slug": "black-friday-deal",
    "rating": 4.85,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 6,
        "5": 64
    },
    "position": 37,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/black-friday-deal/1620646545153.png",
    "__typename": "StockTemplate"
}, {
    "id": 208,
    "name": "Our List",
    "slug": "our-list",
    "rating": 4.68,
    "votes": {
        "1": 2,
        "2": 2,
        "3": 1,
        "4": 9,
        "5": 64
    },
    "position": 32,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/our-list/1617457404738.png",
    "__typename": "StockTemplate"
}, {
    "id": 204,
    "name": "Industry Conference",
    "slug": "industry-conference",
    "rating": 4.78,
    "votes": {
        "3": 2,
        "4": 4,
        "5": 31
    },
    "position": 29,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/industry-conference/1617458312608.png",
    "__typename": "StockTemplate"
}, {
    "id": 202,
    "name": "Summer Break",
    "slug": "summer-break",
    "rating": 4.32,
    "votes": {
        "1": 1,
        "2": 3,
        "3": 4,
        "4": 7,
        "5": 26
    },
    "position": 27,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/summer-break/1602165247731.png",
    "__typename": "StockTemplate"
}, {
    "id": 197,
    "name": "Automobile",
    "slug": "automobile",
    "rating": 4.83,
    "votes": {
        "4": 3,
        "5": 15
    },
    "position": 158,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/automobile/1601821923939.png",
    "__typename": "StockTemplate"
}, {
    "id": 192,
    "name": "Witch Hats Optional",
    "slug": "witch-hats-optional",
    "rating": 4.93,
    "votes": {
        "4": 1,
        "5": 14
    },
    "position": 125,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/witch-hats-optional/1602072909045.png",
    "__typename": "StockTemplate"
}, {
    "id": 191,
    "name": "Plumbing",
    "slug": "plumbing",
    "rating": 4.73,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 9
    },
    "position": 130,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/plumbing/1602150790521.png",
    "__typename": "StockTemplate"
}, {
    "id": 189,
    "name": "Online Music Event",
    "slug": "online-music-event",
    "rating": 3.71,
    "votes": {
        "3": 2,
        "4": 5
    },
    "position": 137,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-music-event/1650878411354.png",
    "__typename": "StockTemplate"
}, {
    "id": 188,
    "name": "New Year Sale",
    "slug": "new-year-sale",
    "rating": 4.56,
    "votes": {
        "1": 1,
        "3": 3,
        "4": 5,
        "5": 25
    },
    "position": 123,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/new-year-sale/1620647034587.png",
    "__typename": "StockTemplate"
}, {
    "id": 178,
    "name": "Cyber Monday Offer",
    "slug": "cyber-monday-offer",
    "rating": 4,
    "votes": {
        "1": 2,
        "2": 1,
        "5": 8
    },
    "position": 49,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-offer/1620646764390.png",
    "__typename": "StockTemplate"
}, {
    "id": 177,
    "name": "Online Healthcare",
    "slug": "online-healthcare",
    "rating": 4.48,
    "votes": {
        "1": 9,
        "2": 1,
        "3": 11,
        "4": 26,
        "5": 119
    },
    "position": 14,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-healthcare/1617448634348.png",
    "__typename": "StockTemplate"
}, {
    "id": 176,
    "name": "Children's Book",
    "slug": "childrens-book",
    "rating": 4.46,
    "votes": {
        "1": 7,
        "2": 5,
        "3": 6,
        "4": 33,
        "5": 112
    },
    "position": 16,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/childrens-book/1617448650069.png",
    "__typename": "StockTemplate"
}, {
    "id": 175,
    "name": "Tour",
    "slug": "tour",
    "rating": 4.92,
    "votes": {
        "3": 1,
        "5": 23
    },
    "position": 156,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/tour/1600269851159.png",
    "__typename": "StockTemplate"
}, {
    "id": 168,
    "name": "House plants",
    "slug": "house-plants",
    "rating": 4.71,
    "votes": {
        "4": 4,
        "5": 10
    },
    "position": 63,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/house-plants/1600324386537.png",
    "__typename": "StockTemplate"
}, {
    "id": 135,
    "name": "Herbal Cosmetics",
    "slug": "herbal-cosmetics",
    "rating": 4.58,
    "votes": {
        "3": 1,
        "4": 3,
        "5": 8
    },
    "position": 102,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/herbal-cosmetics/1618315318779.png",
    "__typename": "StockTemplate"
}, {
    "id": 134,
    "name": "Jewelry",
    "slug": "jewelry",
    "rating": 4.17,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 1,
        "4": 1,
        "5": 8
    },
    "position": 121,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/jewelry/1618400904783.png",
    "__typename": "StockTemplate"
}, {
    "id": 131,
    "name": "IT Services",
    "slug": "it-services",
    "rating": 4.68,
    "votes": {
        "3": 1,
        "4": 6,
        "5": 18
    },
    "position": 155,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/it-services/1617457480782.png",
    "__typename": "StockTemplate"
}, {
    "id": 129,
    "name": "Job Welcome ",
    "slug": "job-welcome",
    "rating": 4.77,
    "votes": {
        "2": 1,
        "3": 3,
        "4": 10,
        "5": 67
    },
    "position": 85,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/job-welcome/1623104003632.png",
    "__typename": "StockTemplate"
}, {
    "id": 117,
    "name": "Customer Welcome",
    "slug": "customer-welcome",
    "rating": 4.47,
    "votes": {
        "1": 2,
        "2": 1,
        "3": 1,
        "4": 11,
        "5": 30
    },
    "position": 128,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/customer-welcome/1623103816019.png",
    "__typename": "StockTemplate"
}, {
    "id": 116,
    "name": "Follow-Up Cart",
    "slug": "abandon-cart",
    "rating": 4.17,
    "votes": {
        "3": 2,
        "4": 1,
        "5": 3
    },
    "position": 149,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/abandon-cart/1627470818018.png",
    "__typename": "StockTemplate"
}, {
    "id": 112,
    "name": "Agriculture",
    "slug": "agriculture",
    "rating": 4.69,
    "votes": {
        "1": 1,
        "2": 1,
        "4": 2,
        "5": 25
    },
    "position": 44,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/agriculture/1616730848872.png",
    "__typename": "StockTemplate"
}, {
    "id": 111,
    "name": "Reminder ",
    "slug": "reminder",
    "rating": 4.45,
    "votes": {
        "1": 16,
        "2": 4,
        "3": 9,
        "4": 50,
        "5": 184
    },
    "position": 12,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/reminder/1623104614253.png",
    "__typename": "StockTemplate"
}, {
    "id": 88,
    "name": "Adventure",
    "slug": "adventure",
    "rating": 4.33,
    "votes": {
        "3": 1,
        "4": 2,
        "5": 3
    },
    "position": 116,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/adventure/1598420211626.png",
    "__typename": "StockTemplate"
}, {
    "id": 84,
    "name": "Realtor",
    "slug": "realtor",
    "rating": 4.77,
    "votes": {
        "2": 1,
        "4": 4,
        "5": 26
    },
    "position": 135,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/realtor/1618314992358.png",
    "__typename": "StockTemplate"
}, {
    "id": 82,
    "name": "Apology Email",
    "slug": "apology-email",
    "rating": 4.79,
    "votes": {
        "2": 1,
        "4": 3,
        "5": 25
    },
    "position": 136,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/apology-email/1597810516174.png",
    "__typename": "StockTemplate"
}, {
    "id": 81,
    "name": "Women's Day Discount",
    "slug": "womens-day-discount",
    "rating": 4.78,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 3,
        "5": 35
    },
    "position": 22,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/womens-day-discount/1637032683551.png",
    "__typename": "StockTemplate"
}, {
    "id": 80,
    "name": "Video Newsletter",
    "slug": "video-newsletter",
    "rating": 4.33,
    "votes": {
        "4": 4,
        "5": 2
    },
    "position": 126,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/video-newsletter/1617457938629.png",
    "__typename": "StockTemplate"
}, {
    "id": 78,
    "name": "Furniture - Single",
    "slug": "furniture-single",
    "rating": 4.66,
    "votes": {
        "1": 8,
        "2": 10,
        "3": 6,
        "4": 57,
        "5": 306
    },
    "position": 4,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/furniture-single/1617448372978.png",
    "__typename": "StockTemplate"
}, {
    "id": 75,
    "name": "Beauty Brand",
    "slug": "beauty-brand",
    "rating": 4.74,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 3,
        "5": 26
    },
    "position": 117,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/beauty-brand/1618402421456.png",
    "__typename": "StockTemplate"
}, {
    "id": 58,
    "name": "Online Course",
    "slug": "online-course",
    "rating": 4.65,
    "votes": {
        "1": 1,
        "4": 3,
        "5": 16
    },
    "position": 88,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/online-course/1597211260144.png",
    "__typename": "StockTemplate"
}, {
    "id": 1,
    "name": "Branding",
    "slug": "branding-company-promotional",
    "rating": 4.74,
    "votes": {
        "1": 4,
        "2": 2,
        "3": 1,
        "4": 16,
        "5": 132
    },
    "position": 56,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/branding-company-promotional/1597157002698.png",
    "__typename": "StockTemplate"
}, {
    "id": 2,
    "name": "Single Product",
    "slug": "single-product",
    "rating": 4.87,
    "votes": {
        "3": 1,
        "5": 14
    },
    "position": 53,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/single-product/1597156973916.png",
    "__typename": "StockTemplate"
}, {
    "id": 4,
    "name": "Magazine Newsletter",
    "slug": "magazine-news-email-template",
    "rating": 3.71,
    "votes": {
        "1": 2,
        "3": 3,
        "4": 4,
        "5": 5
    },
    "position": 46,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/magazine-news-email-template/1597156989580.png",
    "__typename": "StockTemplate"
}, {
    "id": 5,
    "name": "Cyber Monday Sale",
    "slug": "cyber-monday-sale",
    "rating": 4.91,
    "votes": {
        "4": 6,
        "5": 61
    },
    "position": 41,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cyber-monday-sale/1620646755130.png",
    "__typename": "StockTemplate"
}, {
    "id": 6,
    "name": "Delivery Confirmation",
    "slug": "delivery-confirmation",
    "rating": 4.73,
    "votes": {
        "1": 3,
        "2": 2,
        "3": 2,
        "4": 15,
        "5": 116
    },
    "position": 47,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/delivery-confirmation/1617458391730.png",
    "__typename": "StockTemplate"
},{
    "id": 8,
    "name": "Free Drink",
    "slug": "reward-free-giveaway",
    "rating": 4.77,
    "votes": {
        "1": 2,
        "3": 5,
        "4": 17,
        "5": 125
    },
    "position": 43,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/reward-free-giveaway/1597156832958.png",
    "__typename": "StockTemplate"
}, {
    "id": 9,
    "name": "Google Review",
    "slug": "google-review",
    "rating": 4.7,
    "votes": {
        "1": 7,
        "2": 1,
        "3": 14,
        "4": 52,
        "5": 301
    },
    "position": 24,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/google-review/1623104795757.png",
    "__typename": "StockTemplate"
}, {
    "id": 12,
    "name": "Business Promotion Newsletter",
    "slug": "business-promotion-newsletter",
    "rating": 4.46,
    "votes": {
        "1": 1,
        "2": 2,
        "3": 1,
        "4": 10,
        "5": 27
    },
    "position": 28,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/business-promotion-newsletter/1627471586847.png",
    "__typename": "StockTemplate"
}, {
    "id": 19,
    "name": "Simple Offer",
    "slug": "simple-offer",
    "rating": 4.73,
    "votes": {
        "1": 3,
        "2": 3,
        "3": 9,
        "4": 31,
        "5": 217
    },
    "position": 6,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/simple-offer/1636589577156.png",
    "__typename": "StockTemplate"
}, {
    "id": 22,
    "name": "Mobile App Release",
    "slug": "mobile-app-release",
    "rating": 4.79,
    "votes": {
        "1": 1,
        "2": 1,
        "3": 2,
        "4": 19,
        "5": 117
    },
    "position": 42,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/mobile-app-release/1617617715814.png",
    "__typename": "StockTemplate"
}, {
    "id": 24,
    "name": "Cold Email Subscription",
    "slug": "cold-email-subscription",
    "rating": 4.61,
    "votes": {
        "1": 5,
        "2": 2,
        "3": 5,
        "4": 22,
        "5": 116
    },
    "position": 74,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cold-email-subscription/1618483682398.png",
    "__typename": "StockTemplate"
}, {
    "id": 25,
    "name": "Return Product",
    "slug": "return-product-to-cart",
    "rating": 4.85,
    "votes": {
        "3": 1,
        "4": 7,
        "5": 51
    },
    "position": 72,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/return-product-to-cart/1597156267384.png",
    "__typename": "StockTemplate"
}, {
    "id": 26,
    "name": "Soft Drinks",
    "slug": "soft-drinks",
    "rating": 4.76,
    "votes": {
        "4": 4,
        "5": 13
    },
    "position": 64,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/soft-drinks/1616730760772.png",
    "__typename": "StockTemplate"
}, {
    "id": 34,
    "name": "Abandoned Cart",
    "slug": "abandoned-cart",
    "rating": 4.6,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 13,
        "5": 36
    },
    "position": 69,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/abandoned-cart/1597156225018.png",
    "__typename": "StockTemplate"
}, {
    "id": 35,
    "name": "Offer",
    "slug": "offer",
    "rating": 4.56,
    "votes": {
        "1": 2,
        "3": 1,
        "4": 8,
        "5": 30
    },
    "position": 70,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/offer/1597156195508.png",
    "__typename": "StockTemplate"
}, {
    "id": 36,
    "name": "Consulting",
    "slug": "consulting",
    "rating": 4.67,
    "votes": {
        "2": 1,
        "4": 4,
        "5": 16
    },
    "position": 73,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/consulting/1597154762268.png",
    "__typename": "StockTemplate"
}, {
    "id": 39,
    "name": "Cosmetics",
    "slug": "cosmetics",
    "rating": 4.48,
    "votes": {
        "1": 3,
        "4": 1,
        "5": 21
    },
    "position": 48,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/cosmetics/1601731221408.png",
    "__typename": "StockTemplate"
}, {
    "id": 32,
    "name": "Music Promotion",
    "slug": "music-promotion",
    "rating": 4.81,
    "votes": {
        "3": 1,
        "4": 1,
        "5": 14
    },
    "position": 78,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/music-promotion/1650878390604.png",
    "__typename": "StockTemplate"
}, {
    "id": 41,
    "name": "Forgot Password",
    "slug": "notification-forgot-password",
    "rating": 4.71,
    "votes": {
        "1": 9,
        "2": 6,
        "3": 28,
        "4": 102,
        "5": 598
    },
    "position": 59,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/notification-forgot-password/1617617823356.png",
    "__typename": "StockTemplate"
}, {
    "id": 44,
    "name": "Sports Club",
    "slug": "sports-club",
    "rating": 4.75,
    "votes": {
        "3": 1,
        "4": 5,
        "5": 22
    },
    "position": 89,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/sports-club/1618484331898.png",
    "__typename": "StockTemplate"
}, {
    "id": 46,
    "name": "Interior Furniture",
    "slug": "interior-furniture",
    "rating": 4.67,
    "votes": {
        "2": 1,
        "3": 1,
        "4": 7,
        "5": 27
    },
    "position": 50,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/interior-furniture/1618401078681.png",
    "__typename": "StockTemplate"
}, {
    "id": 48,
    "name": "Wine",
    "slug": "wine",
    "rating": 4.55,
    "votes": {
        "1": 1,
        "3": 1,
        "4": 3,
        "5": 15
    },
    "position": 45,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/wine/1616730776328.png",
    "__typename": "StockTemplate"
}, {
    "id": 49,
    "name": "Medical",
    "slug": "medical",
    "rating": 4.78,
    "votes": {
        "1": 2,
        "4": 2,
        "5": 41
    },
    "position": 93,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/medical/1597155622225.png",
    "__typename": "StockTemplate"
}, {
    "id": 51,
    "name": "Green Sale",
    "slug": "green-sale",
    "rating": 4.52,
    "votes": {
        "1": 1,
        "3": 2,
        "4": 13,
        "5": 28
    },
    "position": 34,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/green-sale/1597155587781.png",
    "__typename": "StockTemplate"
}, {
    "id": 29,
    "name": "Real Estate Agency",
    "slug": "real-estate-agency",
    "rating": 4.74,
    "votes": {
        "1": 2,
        "2": 1,
        "4": 7,
        "5": 60
    },
    "position": 75,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/real-estate-agency/1618314750661.png",
    "__typename": "StockTemplate"
}, {
    "id": 30,
    "name": "Camera",
    "slug": "camera",
    "rating": 4.22,
    "votes": {
        "3": 1,
        "4": 5,
        "5": 3
    },
    "position": 71,
    "premium": false,
    "previewUrl": "https://cdn.templates.unlayer.com/previews/camera/1617456587812.png",
    "__typename": "StockTemplate"
}];

export default unlayerTemplates;